/* eslint-disable max-lines */
import React from 'react';
import CartIcon from '@material-ui/icons/ShoppingCart';
import CartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import CartTwoToneIcon from '@material-ui/icons/ShoppingCartTwoTone';
import DescriptionIcon from '@material-ui/icons/Description';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone';
import CardIcon from '@material-ui/icons/CreditCard';
import CardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';
import CardTwoToneIcon from '@material-ui/icons/CreditCardTwoTone';

export const userSteps = [
  {
    title: 'Alinhamento',
    cardDescription: 'Entraremos em contato, no dia e hora agendados, para confirmar todas as informações acordadas no momento do contrato.',
    timelineDescription: 'Confirmação de todas as informações acordadas no momento do contrato, como prazos, documentação necessária e previsão de possíveis contratempos',
    daystilcompletion: 7,
    iconclass: ' icon fas fa-phone',
    id: 0,
  },
  {
    title: 'Documentação',
    cardDescription: 'Aguardamos que envie a documentação necessária para iniciar o processo.',
    timelineDescription: 'Obtenção de toda a documentação necessária para o processo, dependendo de suas especificações',
    daystilcompletion: 14,
    iconclass: ' icon fas fa-id-card',
    id: 1,
  },
  {
    title: 'Apostilamento',
    cardDescription: 'Estamos apostilando os documentos para validação em Portugal',
    timelineDescription: 'Validação dos documentos necessários na Apostila de Haia, para que o documento seja legal em Portugal',
    daystilcompletion: 14,
    iconclass: ' icon fas fa-passport',
    id: 2,
  },
  {
    title: 'Confirmação',
    cardDescription: 'Estamos confirmando a documentação coletada no processo, para enviar à nossa representante legal em Portugal',
    timelineDescription: 'Confirmação de toda a documentação, para verificar se está tudo de acordo com as regras de Portugal',
    daystilcompletion: 7,
    iconclass: ' icon fas fa-folder',
    id: 3,
  },
  {
    title: 'Envio',
    cardDescription: 'Estamos juntando a documentação para envio à nossa advogada representante em Portugal',
    timelineDescription: 'Envio da documentação para Portugal',
    daystilcompletion: 14,
    iconclass: ' icon fas fa-paper-plane',
    id: 4,
  },
  {
    title: 'Acompanhamento',
    cardDescription: 'Acompanhe  por aqui para se informar de atualizações do processo na conservatória',
    timelineDescription: 'Acompanhamento do processo, enquanto ele tramita pela conservatória em Portugal, aos cuidos de nossa representante legal',
    daystilcompletion: 90,
    iconclass: ' icon fas fa-folder-open',
    id: 5,
  },
  {
    title: 'Conclusão',
    cardDescription: 'Parabéns! {texto de congratuações}',
    timelineDescription: 'Conclusão do processo!',
    daystilcompletion: 0,
    iconclass: ' icon fas fa-award',
    id: 6,
  },
];

export const mainConservatorias = [
  'Tondela',
  'Porto',
  'Lisboa',
  'Almada',
  'Braga',
  'Aveiro',
  'Vila nova de Gaia',
  'Pombal',
];

export const alerts = {
};

export const salesDashboardSteps = [
  {
    title: 'Venda',
    icon: <CartIcon />,
    outlinedIcon: <CartOutlinedIcon />,
    twotoneIcon: <CartTwoToneIcon />,
  },
  {
    title: 'Contrato',
    icon: <DescriptionIcon />,
    outlinedIcon: <DescriptionOutlinedIcon />,
    twotoneIcon: <DescriptionTwoToneIcon />,
  },
  {
    title: 'Pagamento',
    icon: <CardIcon />,
    outlinedIcon: <CardOutlinedIcon />,
    twotoneIcon: <CardTwoToneIcon />,
  },
];

export const concelhos = [
  'Abrantes', 'Águeda', 'Aguiar da Beira', 'Alandroal', 'Albergaria-a-Velha', 'Albufeira', 'Alcácer do Sal', 'Alcanena', 'Alcobaça', 'Alcochete', 'Alcoutim', 'Alenquer', 'Alfândega da Fé', 'Alijó', 'Aljezur', 'Aljustrel', 'Almada', 'Almeida', 'Almeirim', 'Almodôvar', 'Alpiarça', 'Alter do Chão', 'Alvaiázere', 'Alvito', 'Amadora', 'Amarante', 'Amares', 'Anadia', 'Angra do Heroísmo', 'Ansião', 'Arcos de Valdevez', 'Arganil', 'Armamar', 'Arouca', 'Arraiolos', 'Arronches', 'Arruda dos Vinhos', 'Aveiro', 'Avis', 'Azambuja', 'Baião', 'Barcelos', 'Barrancos', 'Barreiro', 'Batalha', 'Beja', 'Belmonte', 'Benavente', 'Bombarral', 'Borba', 'Boticas', 'Braga ‏‏‎', 'Bragança', 'Cabeceiras de Basto', 'Cadaval', 'Caldas da Rainha', 'Calheta (Madeira)', 'Calheta (São Jorge)', 'Caminha', 'Campo Maior', 'Cantanhede', 'Carrazeda de Ansiães', 'Carregal do Sal', 'Cartaxo', 'Cascais', 'Castanheira de Pêra', 'Castelo Branco', 'Castelo de Paiva', 'Castelo de Vide', 'Castro Daire', 'Castro Marim', 'Castro Verde', 'Celorico da Beira', 'Celorico de Basto', 'Chamusca', 'Chaves', 'Cinfães', 'Coimbra', 'Condeixa-a-Nova', 'Constância', 'Coruche', 'Corvo', 'Covilhã', 'Crato', 'Cuba', 'Câmara de Lobos', 'Elvas', 'Entroncamento', 'Espinho', 'Esposende', 'Estarreja', 'Estremoz', 'Évora', 'Fafe', 'Faro', 'Felgueiras', 'Ferreira do Alentejo', 'Ferreira do Zêzere', 'Figueira da Foz', 'Figueira de Castelo Rodrigo', 'Figueiró dos Vinhos', 'Fornos de Algodres', 'Freixo de Espada à Cinta', 'Fronteira', 'Funchal', 'Fundão', 'Gavião', 'Golegã', 'Gondomar', 'Gouveia', 'Grândola', 'Guarda', 'Guimarães', 'Góis', 'Horta', 'Idanha-a-Nova', 'Ílhavo', 'Lagoa (Algarve)', 'Lagoa (São Miguel)', 'Lagos', 'Lajes das Flores', 'Lajes do Pico', 'Lamego', 'Leiria', 'Lisboa', 'Loulé', 'Loures', 'Lourinhã', 'Lousã', 'Lousada', 'Mação', 'Macedo de Cavaleiros', 'Machico', 'Madalena', 'Mafra', 'Maia', 'Mangualde', 'Manteigas', 'Marco de Canaveses', 'Marinha Grande', 'Marvão', 'Matosinhos', 'Mealhada', 'Meda', 'Melgaço', 'Mesão Frio', 'Mira', 'Miranda do Corvo', 'Miranda do Douro', 'Mirandela', 'Mogadouro', 'Moimenta da Beira', 'Moita', 'Monção', 'Monchique', 'Mondim de Basto', 'Monforte', 'Montalegre', 'Montemor-o-Novo', 'Montemor-o-Velho', 'Montijo', 'Mora', 'Mortágua', 'Moura', 'Mourão', 'Murça', 'Murtosa', 'Mértola', 'Nazaré', 'Nelas', 'Nisa', 'Nordeste', 'Óbidos', 'Odemira', 'Odivelas', 'Oeiras', 'Oleiros', 'Olhão', 'Oliveira de Azeméis', 'Oliveira de Frades', 'Oliveira do Bairro', 'Oliveira do Hospital', 'Ourique', 'Ourém', 'Ovar', 'Paços de Ferreira', 'Palmela', 'Pampilhosa da Serra', 'Paredes', 'Paredes de Coura', 'Pedrógão Grande', 'Penacova', 'Penafiel', 'Penalva do Castelo', 'Penamacor', 'Penedono', 'Penela', 'Peniche', 'Peso da Régua', 'Pinhel', 'Pombal', 'Ponta Delgada', 'Ponta do Sol', 'Ponte da Barca', 'Ponte de Lima', 'Ponte de Sor', 'Portalegre', 'Portel', 'Portimão', 'Porto', 'Porto Moniz', 'Porto Santo', 'Porto de Mós', 'Povoação', 'Praia da Vitória', 'Proença-a-Nova', 'Póvoa de Lanhoso', 'Póvoa de Varzim', 'Redondo', 'Reguengos de Monsaraz', 'Resende', 'Ribeira Brava', 'Ribeira Grande', 'Ribeira de Pena', 'Rio Maior', 'Sabrosa', 'Sabugal', 'Salvaterra de Magos', 'Santa Comba Dão', 'Santa Cruz', 'Santa Cruz da Graciosa', 'Santa Cruz das Flores', 'Santa Maria da Feira', 'Santa Marta de Penaguião', 'Santana', 'Santarém', 'Santiago do Cacém', 'Santo Tirso', 'São Brás de Alportel', 'São João da Madeira', 'São João da Pesqueira', 'São Pedro do Sul', 'São Roque do Pico', 'São Vicente', 'Sardoal', 'Sátão', 'Seia', 'Seixal', 'Sernancelhe', 'Serpa', 'Sertã', 'Sesimbra', 'Setúbal', 'Sever do Vouga', 'Silves', 'Sines', 'Sintra', 'Sobral de Monte Agraço', 'Soure', 'Sousel', 'Tábua', 'Tabuaço', 'Tarouca', 'Tavira', 'Terras de Bouro', 'Tomar', 'Tondela', 'Torre de Moncorvo', 'Torres Novas', 'Torres Vedras', 'Trancoso', 'Trofa', 'Vagos', 'Vale de Cambra', 'Valença', 'Valongo', 'Valpaços', 'Velas', 'Vendas Novas', 'Viana do Alentejo', 'Viana do Castelo', 'Vidigueira', 'Vieira do Minho', 'Vila Flor', 'Vila Franca de Xira', 'Vila Franca do Campo', 'Vila Nova da Barquinha', 'Vila Nova de Cerveira', 'Vila Nova de Famalicão', 'Vila Nova de Foz Côa', 'Vila Nova de Gaia', 'Vila Nova de Paiva', 'Vila Nova de Poiares', 'Vila Pouca de Aguiar', 'Vila Real', 'Vila Real de Santo António', 'Vila Velha de Ródão', 'Vila Verde', 'Vila Viçosa', 'Vila de Rei', 'Vila do Bispo', 'Vila do Conde', 'Vila do Porto', 'Vimioso', 'Vinhais', 'Viseu', 'Vizela', 'Vouzela',
];

export const citizenRelationship = ['filho', 'neto'];

export const GENDER_MALE = 'MALE';
export const GENDER_FEMALE = 'FEMALE';

export const genders = [
  {
    label: 'Masculino',
    value: GENDER_MALE,
  },
  {
    label: 'Feminino',
    value: GENDER_FEMALE,
  },
];

export const ordinalNumbers = [
  [
    '',
    'Décima',
    'Vigésima',
    'Trigésima',
    'Quadragésima',
    'Quinquagésima',
    'Sexagésima',
    'Septuagésima',
    'Octogésima',
    'Nonagésima',
  ],
  [
    '',
    'Primeira',
    'Segunda',
    'Terceira',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sétima',
    'Oitava',
    'Nona',
  ],
];

export const PAYMENT_METHOD_MONEY = 'PAYMENT_METHOD_MONEY';
export const PAYMENT_METHOD_BANK_TRANSFER = 'PAYMENT_METHOD_BANK_TRANSFER';
export const PAYMENT_METHOD_ONLINE_MAX_PAGO = 'PAYMENT_METHOD_ONLINE_MAX_PAGO';
export const PAYMENT_METHOD_ONLINE_IUGU = 'PAYMENT_METHOD_ONLINE_IUGU';
export const PAYMENT_METHOD_ITAU_BANK_SLIP = 'PAYMENT_METHOD_ONLINE_IUGU';

export const payments = {
  online: [
    { label: 'Max Pago', value: PAYMENT_METHOD_ONLINE_MAX_PAGO },
    { label: 'Iugu', value: PAYMENT_METHOD_ONLINE_IUGU },
  ],
  offline: [
    { label: 'Dinheiro', value: PAYMENT_METHOD_MONEY },
    { label: 'Depósito / Transferência', value: PAYMENT_METHOD_BANK_TRANSFER },
  ],
};

export const acceptedPayments = ['Dinheiro', 'Depósito / Transferência', 'Max Pago', 'IUGU'];

export const PortugueseCertificates = [
  {
    title: 'Registro de batismo',
  },
  {
    title: 'Número de assento (Freguesia e ou Concelho)',
  },
  {
    title: 'Número de assento (Consulado)',
  },
];

export const processTypes = [
  {
    title: 'Atribuição simples',
    description: '',
    id: '0',
  },
  {
    title: 'Aquisição',
    description: '',
    id: '1',
  },
  {
    title: 'Transcrição de casamento',
    description: '',
    id: '2',
  },
  {
    title: 'Naturalização',
    description: '',
    id: '3',
  },

  {
    title: 'Menor de idade',
    description: '',
    id: '4',
  },
  {
    title: 'Menor de idade (até 13 anos)',
    description: '',
    id: '5',
  },
  {
    title: 'Atribuição simples',
    description: '',
    id: '6',
  },
  {
    title: 'Aquisição sefardita',
    description: '',
    id: '7',
  },
  {
    title: 'Busca de certidão brasileira',
    description: '',
    id: '8',
  },
  {
    title: 'Busca de assento português',
    description: '',
    id: '9',
  },
  {
    title: 'Homologação de divórcio',
    description: '',
    id: '10',
  },
  {
    title: 'Homologação de união estável',
    description: '',
    id: '11',
  },
];

export const menuLinks = [
  {
    title: 'Editar informações da conta',
    link: 'conta',
  },
  {
    title: 'Pagamentos',
    link: 'pagamentos',
  },
  {
    title: 'Perguntas frequentes',
    link: 'faq',
  },
];

export const salesMenu = [
  {
    name: 'Vendas',
    title: 'Vendas em aberto',
  },
  {
    name: 'Acompanhamento',
    title: 'Vendas em curso',
  },
  {
    name: 'Histórico',
    title: 'Vendas passadas',
  },
];

export const servicemenuLinks = [
  {
    title: 'Alinhamento',
    link: 'alinhamento',
  },
  {
    title: 'Documentação',
    link: 'documentacao',
  },
  {
    title: 'Análise',
    link: 'analise',
  },
  {
    title: 'Apostilamento',
    link: 'apostilamento',
  },
  {
    title: 'Envio',
    link: 'envio',
  },
  {
    title: 'Acompanhamento',
    link: 'acompanhamento',
  },
  {
    title: 'Busca',
    link: 'busca',
  },
];

export const SiteInfo = {
  title: 'Cidadania Já',
  link: 'https://www.cidadaniaja.com.br/',
  description: 'Somos movidos pela paixão em ajudar famílias a promoverem e exaltarem a sua nacionalidade portuguesa.',
  copyright: '© 2019 CIDADANIA  |  TODOS OS DIREITOS RESERVADOS  |  CNPJ: 34.165.601/0001-76',
  copyright2: 'Uma empresa do grupo Corporações Já',
  socialmedia: [
    {
      title: 'YouTube',
      link: 'https://www.youtube.com/channel/UCz_DUjncu0rcge305cpJFWA',
      iconclass: ' fab fa-youtube',
    },
    {
      title: 'Instagram',
      link: 'https://www.instagram.com/cidadaniaja/',
      iconclass: ' fab fa-instagram',
    },
    {
      title: 'Facebook',
      link: 'https://www.facebook.com/cidadaniajapt/',
      iconclass: ' fab fa-facebook',
    },
  ],
  sitemaplinks: [
    {
      title: 'Processo',
      link: 'processo',
    },
    {
      title: 'Contato',
      link: 'contato',
    },
    {
      title: 'Pagamentos',
      link: 'pagamentos',
    },
    {
      title: 'Termos e Condições',
      link: 'termos-e-condicoes',
    },
    {
      title: 'Perguntas Frequentes',
      link: 'faq',
    },
    {
      title: 'Política de Privacidade',
      link: 'privacidade',
    },

  ],
};

export const semanticMonths = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const shortenedMonths = [
  'Jan.',
  'Fev.',
  'Mar.',
  'Abr.',
  'Mai.',
  'Jun.',
  'Jul.',
  'Ago.',
  'Set.',
  'Out.',
  'Nov.',
  'Dez.',
];

export const countries = [
  {
    translations: {
      br: 'Brasil',
      pt: 'Brasil',
      nl: 'Brazilië',
      hr: 'Brazil',
      fa: 'برزیل',
      de: 'Brasilien',
      es: 'Brasil',
      fr: 'Brésil',
      ja: 'ブラジル',
      it: 'Brasile',
    },
    name: 'Brazil',
    states: [
      { label: 'Acre (AC)', value: 'AC' },
      { label: 'Alagoas (AL)', value: 'AL' },
      { label: 'Amapá (AP)', value: 'AP' },
      { label: 'Amazonas (AM)', value: 'AM' },
      { label: 'Bahia (BA)', value: 'BA' },
      { label: 'Ceará (CE)', value: 'CE' },
      { label: 'Distrito Federal (DF)', value: 'DF' },
      { label: 'Espírito Santo (ES)', value: 'ES' },
      { label: 'Goiás (GO)', value: 'GO' },
      { label: 'Maranhão (MA)', value: 'MA' },
      { label: 'Mato Grosso (MT)', value: 'MT' },
      { label: 'Mato Grosso do Sul (MS)', value: 'MS' },
      { label: 'Minas Gerais (MG)', value: 'MG' },
      { label: 'Pará (PA)', value: 'PA' },
      { label: 'Paraíba (PB)', value: 'PB' },
      { label: 'Paraná (PR)', value: 'PR' },
      { label: 'Pernambuco (PE)', value: 'PE' },
      { label: 'Piauí (PI)', value: 'PI' },
      { label: 'Rio de Janeiro (RJ)', value: 'RJ' },
      { label: 'Rio Grande do Norte (RN)', value: 'RN' },
      { label: 'Rio Grando do Sul (RS)', value: 'RS' },
      { label: 'Rondônia (RO)', value: 'RO' },
      { label: 'Roraima (RR)', value: 'RR' },
      { label: 'Santa Catarina (SC)', value: 'SC' },
      { label: 'São Paulo (SP)', value: 'SP' },
      { label: 'Sergipe (SE)', value: 'SE' },
      { label: 'Tocantins (TO)', value: 'TO' },
    ],
    alpha2Code: 'BR',
    callingCodes: [
      '55',
    ],
    label: 'Brasil',
    value: 'Brasil',
  },
  {
    translations: {
      br: 'Portugal',
      pt: 'Portugal',
      nl: 'Portugal',
      hr: 'Portugal',
      fa: 'پرتغال',
      de: 'Portugal',
      es: 'Portugal',
      fr: 'Portugal',
      ja: 'ポルトガル',
      it: 'Portogallo',
    },
    name: 'Portugal',
    alpha2Code: 'PT',
    callingCodes: [
      '351',
    ],
    label: 'Portugal',
    value: 'Portugal',
  },
  {
    translations: {
      br: 'Afeganistão',
      pt: 'Afeganistão',
      nl: 'Afghanistan',
      hr: 'Afganistan',
      fa: 'افغانستان',
      de: 'Afghanistan',
      es: 'Afganistán',
      fr: 'Afghanistan',
      ja: 'アフガニスタン',
      it: 'Afghanistan',
    },
    name: 'Afghanistan',
    alpha2Code: 'AF',
    callingCodes: [
      '93',
    ],
    label: 'Afeganistão',
    value: 'Afeganistão',
  },
  {
    translations: {
      br: 'Ilhas de Aland',
      pt: 'Ilhas de Aland',
      nl: 'Ålandeilanden',
      hr: 'Ålandski otoci',
      fa: 'جزایر الند',
      de: 'Åland',
      es: 'Alandia',
      fr: 'Åland',
      ja: 'オーランド諸島',
      it: 'Isole Aland',
    },
    name: 'Åland Islands',
    alpha2Code: 'AX',
    callingCodes: [
      '358',
    ],
    label: 'Ilhas de Aland',
    value: 'Ilhas de Aland',
  },
  {
    translations: {
      br: 'Albânia',
      pt: 'Albânia',
      nl: 'Albanië',
      hr: 'Albanija',
      fa: 'آلبانی',
      de: 'Albanien',
      es: 'Albania',
      fr: 'Albanie',
      ja: 'アルバニア',
      it: 'Albania',
    },
    name: 'Albania',
    alpha2Code: 'AL',
    callingCodes: [
      '355',
    ],
    label: 'Albânia',
    value: 'Albânia',
  },
  {
    translations: {
      br: 'Argélia',
      pt: 'Argélia',
      nl: 'Algerije',
      hr: 'Alžir',
      fa: 'الجزایر',
      de: 'Algerien',
      es: 'Argelia',
      fr: 'Algérie',
      ja: 'アルジェリア',
      it: 'Algeria',
    },
    name: 'Algeria',
    alpha2Code: 'DZ',
    callingCodes: [
      '213',
    ],
    label: 'Argélia',
    value: 'Argélia',
  },
  {
    translations: {
      br: 'Samoa Americana',
      pt: 'Samoa Americana',
      nl: 'Amerikaans Samoa',
      hr: 'Američka Samoa',
      fa: 'ساموآی آمریکا',
      de: 'Amerikanisch-Samoa',
      es: 'Samoa Americana',
      fr: 'Samoa américaines',
      ja: 'アメリカ領サモア',
      it: 'Samoa Americane',
    },
    name: 'American Samoa',
    alpha2Code: 'AS',
    callingCodes: [
      '1684',
    ],
    label: 'Samoa Americana',
    value: 'Samoa Americana',
  },
  {
    translations: {
      br: 'Andorra',
      pt: 'Andorra',
      nl: 'Andorra',
      hr: 'Andora',
      fa: 'آندورا',
      de: 'Andorra',
      es: 'Andorra',
      fr: 'Andorre',
      ja: 'アンドラ',
      it: 'Andorra',
    },
    name: 'Andorra',
    alpha2Code: 'AD',
    callingCodes: [
      '376',
    ],
    label: 'Andorra',
    value: 'Andorra',
  },
  {
    translations: {
      br: 'Angola',
      pt: 'Angola',
      nl: 'Angola',
      hr: 'Angola',
      fa: 'آنگولا',
      de: 'Angola',
      es: 'Angola',
      fr: 'Angola',
      ja: 'アンゴラ',
      it: 'Angola',
    },
    name: 'Angola',
    alpha2Code: 'AO',
    callingCodes: [
      '244',
    ],
    label: 'Angola',
    value: 'Angola',
  },
  {
    translations: {
      br: 'Anguila',
      pt: 'Anguila',
      nl: 'Anguilla',
      hr: 'Angvila',
      fa: 'آنگویلا',
      de: 'Anguilla',
      es: 'Anguilla',
      fr: 'Anguilla',
      ja: 'アンギラ',
      it: 'Anguilla',
    },
    name: 'Anguilla',
    alpha2Code: 'AI',
    callingCodes: [
      '1264',
    ],
    label: 'Anguila',
    value: 'Anguila',
  },
  {
    translations: {
      br: 'Antártida',
      pt: 'Antárctida',
      nl: 'Antarctica',
      hr: 'Antarktika',
      fa: 'جنوبگان',
      de: 'Antarktika',
      es: 'Antártida',
      fr: 'Antarctique',
      ja: '南極大陸',
      it: 'Antartide',
    },
    name: 'Antarctica',
    alpha2Code: 'AQ',
    callingCodes: [
      '672',
    ],
    label: 'Antártida',
    value: 'Antártida',
  },
  {
    translations: {
      br: 'Antígua e Barbuda',
      pt: 'Antígua e Barbuda',
      nl: 'Antigua en Barbuda',
      hr: 'Antigva i Barbuda',
      fa: 'آنتیگوا و باربودا',
      de: 'Antigua und Barbuda',
      es: 'Antigua y Barbuda',
      fr: 'Antigua-et-Barbuda',
      ja: 'アンティグア・バーブーダ',
      it: 'Antigua e Barbuda',
    },
    name: 'Antigua and Barbuda',
    alpha2Code: 'AG',
    callingCodes: [
      '1268',
    ],
    label: 'Antígua e Barbuda',
    value: 'Antígua e Barbuda',
  },
  {
    translations: {
      br: 'Argentina',
      pt: 'Argentina',
      nl: 'Argentinië',
      hr: 'Argentina',
      fa: 'آرژانتین',
      de: 'Argentinien',
      es: 'Argentina',
      fr: 'Argentine',
      ja: 'アルゼンチン',
      it: 'Argentina',
    },
    name: 'Argentina',
    alpha2Code: 'AR',
    callingCodes: [
      '54',
    ],
    label: 'Argentina',
    value: 'Argentina',
  },
  {
    translations: {
      br: 'Armênia',
      pt: 'Arménia',
      nl: 'Armenië',
      hr: 'Armenija',
      fa: 'ارمنستان',
      de: 'Armenien',
      es: 'Armenia',
      fr: 'Arménie',
      ja: 'アルメニア',
      it: 'Armenia',
    },
    name: 'Armenia',
    alpha2Code: 'AM',
    callingCodes: [
      '374',
    ],
    label: 'Armênia',
    value: 'Armênia',
  },
  {
    translations: {
      br: 'Aruba',
      pt: 'Aruba',
      nl: 'Aruba',
      hr: 'Aruba',
      fa: 'آروبا',
      de: 'Aruba',
      es: 'Aruba',
      fr: 'Aruba',
      ja: 'アルバ',
      it: 'Aruba',
    },
    name: 'Aruba',
    alpha2Code: 'AW',
    callingCodes: [
      '297',
    ],
    label: 'Aruba',
    value: 'Aruba',
  },
  {
    translations: {
      br: 'Austrália',
      pt: 'Austrália',
      nl: 'Australië',
      hr: 'Australija',
      fa: 'استرالیا',
      de: 'Australien',
      es: 'Australia',
      fr: 'Australie',
      ja: 'オーストラリア',
      it: 'Australia',
    },
    name: 'Australia',
    alpha2Code: 'AU',
    callingCodes: [
      '61',
    ],
    label: 'Austrália',
    value: 'Austrália',
  },
  {
    translations: {
      br: 'áustria',
      pt: 'áustria',
      nl: 'Oostenrijk',
      hr: 'Austrija',
      fa: 'اتریش',
      de: 'Österreich',
      es: 'Austria',
      fr: 'Autriche',
      ja: 'オーストリア',
      it: 'Austria',
    },
    name: 'Austria',
    alpha2Code: 'AT',
    callingCodes: [
      '43',
    ],
    label: 'áustria',
    value: 'áustria',
  },
  {
    translations: {
      br: 'Azerbaijão',
      pt: 'Azerbaijão',
      nl: 'Azerbeidzjan',
      hr: 'Azerbajdžan',
      fa: 'آذربایجان',
      de: 'Aserbaidschan',
      es: 'Azerbaiyán',
      fr: 'Azerbaïdjan',
      ja: 'アゼルバイジャン',
      it: 'Azerbaijan',
    },
    name: 'Azerbaijan',
    alpha2Code: 'AZ',
    callingCodes: [
      '994',
    ],
    label: 'Azerbaijão',
    value: 'Azerbaijão',
  },
  {
    translations: {
      br: 'Bahamas',
      pt: 'Baamas',
      nl: 'Bahama’s',
      hr: 'Bahami',
      fa: 'باهاما',
      de: 'Bahamas',
      es: 'Bahamas',
      fr: 'Bahamas',
      ja: 'バハマ',
      it: 'Bahamas',
    },
    name: 'Bahamas',
    alpha2Code: 'BS',
    callingCodes: [
      '1242',
    ],
    label: 'Bahamas',
    value: 'Bahamas',
  },
  {
    translations: {
      br: 'Bahrein',
      pt: 'Barém',
      nl: 'Bahrein',
      hr: 'Bahrein',
      fa: 'بحرین',
      de: 'Bahrain',
      es: 'Bahrein',
      fr: 'Bahreïn',
      ja: 'バーレーン',
      it: 'Bahrein',
    },
    name: 'Bahrain',
    alpha2Code: 'BH',
    callingCodes: [
      '973',
    ],
    label: 'Bahrein',
    value: 'Bahrein',
  },
  {
    translations: {
      br: 'Bangladesh',
      pt: 'Bangladeche',
      nl: 'Bangladesh',
      hr: 'Bangladeš',
      fa: 'بنگلادش',
      de: 'Bangladesch',
      es: 'Bangladesh',
      fr: 'Bangladesh',
      ja: 'バングラデシュ',
      it: 'Bangladesh',
    },
    name: 'Bangladesh',
    alpha2Code: 'BD',
    callingCodes: [
      '880',
    ],
    label: 'Bangladesh',
    value: 'Bangladesh',
  },
  {
    translations: {
      br: 'Barbados',
      pt: 'Barbados',
      nl: 'Barbados',
      hr: 'Barbados',
      fa: 'باربادوس',
      de: 'Barbados',
      es: 'Barbados',
      fr: 'Barbade',
      ja: 'バルバドス',
      it: 'Barbados',
    },
    name: 'Barbados',
    alpha2Code: 'BB',
    callingCodes: [
      '1246',
    ],
    label: 'Barbados',
    value: 'Barbados',
  },
  {
    translations: {
      br: 'Bielorrússia',
      pt: 'Bielorrússia',
      nl: 'Wit-Rusland',
      hr: 'Bjelorusija',
      fa: 'بلاروس',
      de: 'Weißrussland',
      es: 'Bielorrusia',
      fr: 'Biélorussie',
      ja: 'ベラルーシ',
      it: 'Bielorussia',
    },
    name: 'Belarus',
    alpha2Code: 'BY',
    callingCodes: [
      '375',
    ],
    label: 'Bielorrússia',
    value: 'Bielorrússia',
  },
  {
    translations: {
      br: 'Bélgica',
      pt: 'Bélgica',
      nl: 'België',
      hr: 'Belgija',
      fa: 'بلژیک',
      de: 'Belgien',
      es: 'Bélgica',
      fr: 'Belgique',
      ja: 'ベルギー',
      it: 'Belgio',
    },
    name: 'Belgium',
    alpha2Code: 'BE',
    callingCodes: [
      '32',
    ],
    label: 'Bélgica',
    value: 'Bélgica',
  },
  {
    translations: {
      br: 'Belize',
      pt: 'Belize',
      nl: 'Belize',
      hr: 'Belize',
      fa: 'بلیز',
      de: 'Belize',
      es: 'Belice',
      fr: 'Belize',
      ja: 'ベリーズ',
      it: 'Belize',
    },
    name: 'Belize',
    alpha2Code: 'BZ',
    callingCodes: [
      '501',
    ],
    label: 'Belize',
    value: 'Belize',
  },
  {
    translations: {
      br: 'Benin',
      pt: 'Benim',
      nl: 'Benin',
      hr: 'Benin',
      fa: 'بنین',
      de: 'Benin',
      es: 'Benín',
      fr: 'Bénin',
      ja: 'ベナン',
      it: 'Benin',
    },
    name: 'Benin',
    alpha2Code: 'BJ',
    callingCodes: [
      '229',
    ],
    label: 'Benin',
    value: 'Benin',
  },
  {
    translations: {
      br: 'Bermudas',
      pt: 'Bermudas',
      nl: 'Bermuda',
      hr: 'Bermudi',
      fa: 'برمودا',
      de: 'Bermuda',
      es: 'Bermudas',
      fr: 'Bermudes',
      ja: 'バミューダ',
      it: 'Bermuda',
    },
    name: 'Bermuda',
    alpha2Code: 'BM',
    callingCodes: [
      '1441',
    ],
    label: 'Bermudas',
    value: 'Bermudas',
  },
  {
    translations: {
      br: 'Butão',
      pt: 'Butão',
      nl: 'Bhutan',
      hr: 'Butan',
      fa: 'بوتان',
      de: 'Bhutan',
      es: 'Bután',
      fr: 'Bhoutan',
      ja: 'ブータン',
      it: 'Bhutan',
    },
    name: 'Bhutan',
    alpha2Code: 'BT',
    callingCodes: [
      '975',
    ],
    label: 'Butão',
    value: 'Butão',
  },
  {
    translations: {
      br: 'Bolívia',
      pt: 'Bolívia',
      nl: 'Bolivia',
      hr: 'Bolivija',
      fa: 'بولیوی',
      de: 'Bolivien',
      es: 'Bolivia',
      fr: 'Bolivie',
      ja: 'ボリビア多民族国',
      it: 'Bolivia',
    },
    name: 'Bolivia (Plurinational State of)',
    alpha2Code: 'BO',
    callingCodes: [
      '591',
    ],
    label: 'Bolívia',
    value: 'Bolívia',
  },
  {
    translations: {
      br: 'Bonaire',
      pt: 'Bonaire',
      fa: 'بونیر',
      de: 'Bonaire, Sint Eustatius und Saba',
      fr: 'Bonaire, Saint-Eustache et Saba',
      it: 'Bonaire, Saint-Eustache e Saba',
    },
    name: 'Bonaire, Sint Eustatius and Saba',
    alpha2Code: 'BQ',
    callingCodes: [
      '5997',
    ],
    label: 'Bonaire',
    value: 'Bonaire',
  },
  {
    translations: {
      br: 'Bósnia e Herzegovina',
      pt: 'Bósnia e Herzegovina',
      nl: 'Bosnië en Herzegovina',
      hr: 'Bosna i Hercegovina',
      fa: 'بوسنی و هرزگوین',
      de: 'Bosnien und Herzegowina',
      es: 'Bosnia y Herzegovina',
      fr: 'Bosnie-Herzégovine',
      ja: 'ボスニア・ヘルツェゴビナ',
      it: 'Bosnia ed Erzegovina',
    },
    name: 'Bosnia and Herzegovina',
    alpha2Code: 'BA',
    callingCodes: [
      '387',
    ],
    label: 'Bósnia e Herzegovina',
    value: 'Bósnia e Herzegovina',
  },
  {
    translations: {
      br: 'Botsuana',
      pt: 'Botsuana',
      nl: 'Botswana',
      hr: 'Bocvana',
      fa: 'بوتسوانا',
      de: 'Botswana',
      es: 'Botswana',
      fr: 'Botswana',
      ja: 'ボツワナ',
      it: 'Botswana',
    },
    name: 'Botswana',
    alpha2Code: 'BW',
    callingCodes: [
      '267',
    ],
    label: 'Botsuana',
    value: 'Botsuana',
  },
  {
    translations: {
      br: 'Ilha Bouvet',
      pt: 'Ilha Bouvet',
      nl: 'Bouveteiland',
      hr: 'Otok Bouvet',
      fa: 'جزیره بووه',
      de: 'Bouvetinsel',
      es: 'Isla Bouvet',
      fr: 'Île Bouvet',
      ja: 'ブーベ島',
      it: 'Isola Bouvet',
    },
    name: 'Bouvet Island',
    alpha2Code: 'BV',
    callingCodes: [
      '',
    ],
    label: 'Ilha Bouvet',
    value: 'Ilha Bouvet',
  },
  {
    translations: {
      br: 'Território Britânico do Oceano Índico',
      pt: 'Território Britânico do Oceano Índico',
      nl: 'Britse Gebieden in de Indische Oceaan',
      hr: 'Britanski Indijskooceanski teritorij',
      fa: 'قلمرو بریتانیا در اقیانوس هند',
      de: 'Britisches Territorium im Indischen Ozean',
      es: 'Territorio Británico del Océano Índico',
      fr: 'Territoire britannique de l\'océan Indien',
      ja: 'イギリス領インド洋地域',
      it: 'Territorio britannico dell\'oceano indiano',
    },
    name: 'British Indian Ocean Territory',
    alpha2Code: 'IO',
    callingCodes: [
      '246',
    ],
    label: 'Território Britânico do Oceano íÍdico',
    value: 'Território Britânico do Oceano íÍdico',
  },
  {
    translations: {
      br: 'Ilhas Menores Distantes dos Estados Unidos',
      pt: 'Ilhas Menores Distantes dos Estados Unidos',
      nl: 'Kleine afgelegen eilanden van de Verenigde Staten',
      hr: 'Mali udaljeni otoci SAD-a',
      fa: 'جزایر کوچک حاشیه‌ای ایالات متحده آمریکا',
      de: 'Kleinere Inselbesitzungen der Vereinigten Staaten',
      es: 'Islas Ultramarinas Menores de Estados Unidos',
      fr: 'Îles mineures éloignées des États-Unis',
      ja: '合衆国領有小離島',
      it: 'Isole minori esterne degli Stati Uniti d\'America',
    },
    name: 'United States Minor Outlying Islands',
    alpha2Code: 'UM',
    callingCodes: [
      '',
    ],
    label: 'Ilhas Menores Distantes dos Estados Unidos',
    value: 'Ilhas Menores Distantes dos Estados Unidos',
  },
  {
    translations: {
      br: 'Ilhas Virgens Britânicas',
      pt: 'Ilhas Virgens Britânicas',
      nl: 'Britse Maagdeneilanden',
      hr: 'Britanski Djevičanski Otoci',
      fa: 'جزایر ویرجین بریتانیا',
      de: 'Britische Jungferninseln',
      es: 'Islas Vírgenes del Reino Unido',
      fr: 'Îles Vierges britanniques',
      ja: 'イギリス領ヴァージン諸島',
      it: 'Isole Vergini Britanniche',
    },
    name: 'Virgin Islands (British)',
    alpha2Code: 'VG',
    callingCodes: [
      '1284',
    ],
    label: 'Ilhas Virgens Britânicas',
    value: 'Ilhas Virgens Britânicas',
  },
  {
    translations: {
      br: 'Ilhas Virgens Americanas',
      pt: 'Ilhas Virgens Americanas',
      nl: 'Verenigde Staten Maagdeneilanden',
      fa: 'جزایر ویرجین آمریکا',
      de: 'Amerikanische Jungferninseln',
      es: 'Islas Vírgenes de los Estados Unidos',
      fr: 'Îles Vierges des États-Unis',
      ja: 'アメリカ領ヴァージン諸島',
      it: 'Isole Vergini americane',
    },
    name: 'Virgin Islands (U.S.)',
    alpha2Code: 'VI',
    callingCodes: [
      '1 340',
    ],
    label: 'Ilhas Virgens Americanas',
    value: 'Ilhas Virgens Americanas',
  },
  {
    translations: {
      br: 'Brunei',
      pt: 'Brunei',
      nl: 'Brunei',
      hr: 'Brunej',
      fa: 'برونئی',
      de: 'Brunei',
      es: 'Brunei',
      fr: 'Brunei',
      ja: 'ブルネイ・ダルサラーム',
      it: 'Brunei',
    },
    name: 'Brunei Darussalam',
    alpha2Code: 'BN',
    callingCodes: [
      '673',
    ],
    label: 'Brunei',
    value: 'Brunei',
  },
  {
    translations: {
      br: 'Bulgária',
      pt: 'Bulgária',
      nl: 'Bulgarije',
      hr: 'Bugarska',
      fa: 'بلغارستان',
      de: 'Bulgarien',
      es: 'Bulgaria',
      fr: 'Bulgarie',
      ja: 'ブルガリア',
      it: 'Bulgaria',
    },
    name: 'Bulgaria',
    alpha2Code: 'BG',
    callingCodes: [
      '359',
    ],
    label: 'Bulgária',
    value: 'Bulgária',
  },
  {
    translations: {
      br: 'Burkina Faso',
      pt: 'Burquina Faso',
      nl: 'Burkina Faso',
      hr: 'Burkina Faso',
      fa: 'بورکینافاسو',
      de: 'Burkina Faso',
      es: 'Burkina Faso',
      fr: 'Burkina Faso',
      ja: 'ブルキナファソ',
      it: 'Burkina Faso',
    },
    name: 'Burkina Faso',
    alpha2Code: 'BF',
    callingCodes: [
      '226',
    ],
    label: 'Burkina Faso',
    value: 'Burkina Faso',
  },
  {
    translations: {
      br: 'Burundi',
      pt: 'Burúndi',
      nl: 'Burundi',
      hr: 'Burundi',
      fa: 'بوروندی',
      de: 'Burundi',
      es: 'Burundi',
      fr: 'Burundi',
      ja: 'ブルンジ',
      it: 'Burundi',
    },
    name: 'Burundi',
    alpha2Code: 'BI',
    callingCodes: [
      '257',
    ],
    label: 'Burundi',
    value: 'Burundi',
  },
  {
    translations: {
      br: 'Camboja',
      pt: 'Camboja',
      nl: 'Cambodja',
      hr: 'Kambodža',
      fa: 'کامبوج',
      de: 'Kambodscha',
      es: 'Camboya',
      fr: 'Cambodge',
      ja: 'カンボジア',
      it: 'Cambogia',
    },
    name: 'Cambodia',
    alpha2Code: 'KH',
    callingCodes: [
      '855',
    ],
    label: 'Camboja',
    value: 'Camboja',
  },
  {
    translations: {
      br: 'Camarões',
      pt: 'Camarões',
      nl: 'Kameroen',
      hr: 'Kamerun',
      fa: 'کامرون',
      de: 'Kamerun',
      es: 'Camerún',
      fr: 'Cameroun',
      ja: 'カメルーン',
      it: 'Camerun',
    },
    name: 'Cameroon',
    alpha2Code: 'CM',
    callingCodes: [
      '237',
    ],
    label: 'Camarões',
    value: 'Camarões',
  },
  {
    translations: {
      br: 'Canadá',
      pt: 'Canadá',
      nl: 'Canada',
      hr: 'Kanada',
      fa: 'کانادا',
      de: 'Kanada',
      es: 'Canadá',
      fr: 'Canada',
      ja: 'カナダ',
      it: 'Canada',
    },
    name: 'Canada',
    alpha2Code: 'CA',
    callingCodes: [
      '1',
    ],
    label: 'Canadá',
    value: 'Canadá',
  },
  {
    translations: {
      br: 'Cabo Verde',
      pt: 'Cabo Verde',
      nl: 'Kaapverdië',
      hr: 'Zelenortska Republika',
      fa: 'کیپ ورد',
      de: 'Kap Verde',
      es: 'Cabo Verde',
      fr: 'Cap Vert',
      ja: 'カーボベルデ',
      it: 'Capo Verde',
    },
    name: 'Cabo Verde',
    alpha2Code: 'CV',
    callingCodes: [
      '238',
    ],
    label: 'Cabo Verde',
    value: 'Cabo Verde',
  },
  {
    translations: {
      br: 'Ilhas Cayman',
      pt: 'Ilhas Caimão',
      nl: 'Caymaneilanden',
      hr: 'Kajmanski otoci',
      fa: 'جزایر کیمن',
      de: 'Kaimaninseln',
      es: 'Islas Caimán',
      fr: 'Îles Caïmans',
      ja: 'ケイマン諸島',
      it: 'Isole Cayman',
    },
    name: 'Cayman Islands',
    alpha2Code: 'KY',
    callingCodes: [
      '1345',
    ],
    label: 'Ilhas Cayman',
    value: 'Ilhas Cayman',
  },
  {
    translations: {
      br: 'República Centro-Africana',
      pt: 'República Centro-Africana',
      nl: 'Centraal-Afrikaanse Republiek',
      hr: 'Srednjoafrička Republika',
      fa: 'جمهوری آفریقای مرکزی',
      de: 'Zentralafrikanische Republik',
      es: 'República Centroafricana',
      fr: 'République centrafricaine',
      ja: '中央アフリカ共和国',
      it: 'Repubblica Centrafricana',
    },
    name: 'Central African Republic',
    alpha2Code: 'CF',
    callingCodes: [
      '236',
    ],
    label: 'República Centro-Africana',
    value: 'República Centro-Africana',
  },
  {
    translations: {
      br: 'Chade',
      pt: 'Chade',
      nl: 'Tsjaad',
      hr: 'Čad',
      fa: 'چاد',
      de: 'Tschad',
      es: 'Chad',
      fr: 'Tchad',
      ja: 'チャド',
      it: 'Ciad',
    },
    name: 'Chad',
    alpha2Code: 'TD',
    callingCodes: [
      '235',
    ],
    label: 'Chade',
    value: 'Chade',
  },
  {
    translations: {
      br: 'Chile',
      pt: 'Chile',
      nl: 'Chili',
      hr: 'Čile',
      fa: 'شیلی',
      de: 'Chile',
      es: 'Chile',
      fr: 'Chili',
      ja: 'チリ',
      it: 'Cile',
    },
    name: 'Chile',
    alpha2Code: 'CL',
    callingCodes: [
      '56',
    ],
    label: 'Chile',
    value: 'Chile',
  },
  {
    translations: {
      br: 'China',
      pt: 'China',
      nl: 'China',
      hr: 'Kina',
      fa: 'چین',
      de: 'China',
      es: 'China',
      fr: 'Chine',
      ja: '中国',
      it: 'Cina',
    },
    name: 'China',
    alpha2Code: 'CN',
    callingCodes: [
      '86',
    ],
    label: 'China',
    value: 'China',
  },
  {
    translations: {
      br: 'Ilha Christmas',
      pt: 'Ilha do Natal',
      nl: 'Christmaseiland',
      hr: 'Božićni otok',
      fa: 'جزیره کریسمس',
      de: 'Weihnachtsinsel',
      es: 'Isla de Navidad',
      fr: 'Île Christmas',
      ja: 'クリスマス島',
      it: 'Isola di Natale',
    },
    name: 'Christmas Island',
    alpha2Code: 'CX',
    callingCodes: [
      '61',
    ],
    label: 'Ilha Christmas',
    value: 'Ilha Christmas',
  },
  {
    translations: {
      br: 'Ilhas Cocos',
      pt: 'Ilhas dos Cocos',
      nl: 'Cocoseilanden',
      hr: 'Kokosovi Otoci',
      fa: 'جزایر کوکوس',
      de: 'Kokosinseln',
      es: 'Islas Cocos o Islas Keeling',
      fr: 'Îles Cocos',
      ja: 'ココス（キーリング）諸島',
      it: 'Isole Cocos e Keeling',
    },
    name: 'Cocos (Keeling) Islands',
    alpha2Code: 'CC',
    callingCodes: [
      '61',
    ],
    label: 'Ilhas Cocos',
    value: 'Ilhas Cocos',
  },
  {
    translations: {
      br: 'Colômbia',
      pt: 'Colômbia',
      nl: 'Colombia',
      hr: 'Kolumbija',
      fa: 'کلمبیا',
      de: 'Kolumbien',
      es: 'Colombia',
      fr: 'Colombie',
      ja: 'コロンビア',
      it: 'Colombia',
    },
    name: 'Colombia',
    alpha2Code: 'CO',
    callingCodes: [
      '57',
    ],
    label: 'Colômbia',
    value: 'Colômbia',
  },
  {
    translations: {
      br: 'Comores',
      pt: 'Comores',
      nl: 'Comoren',
      hr: 'Komori',
      fa: 'کومور',
      de: 'Union der Komoren',
      es: 'Comoras',
      fr: 'Comores',
      ja: 'コモロ',
      it: 'Comore',
    },
    name: 'Comoros',
    alpha2Code: 'KM',
    callingCodes: [
      '269',
    ],
    label: 'Comores',
    value: 'Comores',
  },
  {
    translations: {
      br: 'Congo',
      pt: 'Congo',
      nl: 'Congo [Republiek]',
      hr: 'Kongo',
      fa: 'کنگو',
      de: 'Kongo',
      es: 'Congo',
      fr: 'Congo',
      ja: 'コンゴ共和国',
      it: 'Congo',
    },
    name: 'Congo',
    alpha2Code: 'CG',
    callingCodes: [
      '242',
    ],
    label: 'Congo',
    value: 'Congo',
  },
  {
    translations: {
      br: 'RD Congo',
      pt: 'RD Congo',
      nl: 'Congo [DRC]',
      hr: 'Kongo, Demokratska Republika',
      fa: 'جمهوری کنگو',
      de: 'Kongo (Dem. Rep.)',
      es: 'Congo (Rep. Dem.)',
      fr: 'Congo (Rép. dém.)',
      ja: 'コンゴ民主共和国',
      it: 'Congo (Rep. Dem.)',
    },
    name: 'Congo (Democratic Republic of the)',
    alpha2Code: 'CD',
    callingCodes: [
      '243',
    ],
    label: 'RD Congo',
    value: 'RD Congo',
  },
  {
    translations: {
      br: 'Ilhas Cook',
      pt: 'Ilhas Cook',
      nl: 'Cookeilanden',
      hr: 'Cookovo Otočje',
      fa: 'جزایر کوک',
      de: 'Cookinseln',
      es: 'Islas Cook',
      fr: 'Îles Cook',
      ja: 'クック諸島',
      it: 'Isole Cook',
    },
    name: 'Cook Islands',
    alpha2Code: 'CK',
    callingCodes: [
      '682',
    ],
    label: 'Ilhas Cook',
    value: 'Ilhas Cook',
  },
  {
    translations: {
      br: 'Costa Rica',
      pt: 'Costa Rica',
      nl: 'Costa Rica',
      hr: 'Kostarika',
      fa: 'کاستاریکا',
      de: 'Costa Rica',
      es: 'Costa Rica',
      fr: 'Costa Rica',
      ja: 'コスタリカ',
      it: 'Costa Rica',
    },
    name: 'Costa Rica',
    alpha2Code: 'CR',
    callingCodes: [
      '506',
    ],
    label: 'Costa Rica',
    value: 'Costa Rica',
  },
  {
    translations: {
      br: 'Croácia',
      pt: 'Croácia',
      nl: 'Kroatië',
      hr: 'Hrvatska',
      fa: 'کرواسی',
      de: 'Kroatien',
      es: 'Croacia',
      fr: 'Croatie',
      ja: 'クロアチア',
      it: 'Croazia',
    },
    name: 'Croatia',
    alpha2Code: 'HR',
    callingCodes: [
      '385',
    ],
    label: 'Croácia',
    value: 'Croácia',
  },
  {
    translations: {
      br: 'Cuba',
      pt: 'Cuba',
      nl: 'Cuba',
      hr: 'Kuba',
      fa: 'کوبا',
      de: 'Kuba',
      es: 'Cuba',
      fr: 'Cuba',
      ja: 'キューバ',
      it: 'Cuba',
    },
    name: 'Cuba',
    alpha2Code: 'CU',
    callingCodes: [
      '53',
    ],
    label: 'Cuba',
    value: 'Cuba',
  },
  {
    translations: {
      br: 'Curaçao',
      pt: 'Curaçao',
      nl: 'Curaçao',
      fa: 'کوراسائو',
      de: 'Curaçao',
      fr: 'Curaçao',
      it: 'Curaçao',
    },
    name: 'Curaçao',
    alpha2Code: 'CW',
    callingCodes: [
      '599',
    ],
    label: 'Curaçao',
    value: 'Curaçao',
  },
  {
    translations: {
      br: 'Chipre',
      pt: 'Chipre',
      nl: 'Cyprus',
      hr: 'Cipar',
      fa: 'قبرس',
      de: 'Zypern',
      es: 'Chipre',
      fr: 'Chypre',
      ja: 'キプロス',
      it: 'Cipro',
    },
    name: 'Cyprus',
    alpha2Code: 'CY',
    callingCodes: [
      '357',
    ],
    label: 'Chipre',
    value: 'Chipre',
  },
  {
    translations: {
      br: 'República Tcheca',
      pt: 'República Checa',
      nl: 'Tsjechië',
      hr: 'Češka',
      fa: 'جمهوری چک',
      de: 'Tschechische Republik',
      es: 'República Checa',
      fr: 'République tchèque',
      ja: 'チェコ',
      it: 'Repubblica Ceca',
    },
    name: 'Czech Republic',
    alpha2Code: 'CZ',
    callingCodes: [
      '420',
    ],
    label: 'República Tcheca',
    value: 'República Tcheca',
  },
  {
    translations: {
      br: 'Dinamarca',
      pt: 'Dinamarca',
      nl: 'Denemarken',
      hr: 'Danska',
      fa: 'دانمارک',
      de: 'Dänemark',
      es: 'Dinamarca',
      fr: 'Danemark',
      ja: 'デンマーク',
      it: 'Danimarca',
    },
    name: 'Denmark',
    alpha2Code: 'DK',
    callingCodes: [
      '45',
    ],
    label: 'Dinamarca',
    value: 'Dinamarca',
  },
  {
    translations: {
      br: 'Djibuti',
      pt: 'Djibuti',
      nl: 'Djibouti',
      hr: 'Džibuti',
      fa: 'جیبوتی',
      de: 'Dschibuti',
      es: 'Yibuti',
      fr: 'Djibouti',
      ja: 'ジブチ',
      it: 'Gibuti',
    },
    name: 'Djibouti',
    alpha2Code: 'DJ',
    callingCodes: [
      '253',
    ],
    label: 'Djibuti',
    value: 'Djibuti',
  },
  {
    translations: {
      br: 'Dominica',
      pt: 'Dominica',
      nl: 'Dominica',
      hr: 'Dominika',
      fa: 'دومینیکا',
      de: 'Dominica',
      es: 'Dominica',
      fr: 'Dominique',
      ja: 'ドミニカ国',
      it: 'Dominica',
    },
    name: 'Dominica',
    alpha2Code: 'DM',
    callingCodes: [
      '1767',
    ],
    label: 'Dominica',
    value: 'Dominica',
  },
  {
    translations: {
      br: 'República Dominicana',
      pt: 'República Dominicana',
      nl: 'Dominicaanse Republiek',
      hr: 'Dominikanska Republika',
      fa: 'جمهوری دومینیکن',
      de: 'Dominikanische Republik',
      es: 'República Dominicana',
      fr: 'République dominicaine',
      ja: 'ドミニカ共和国',
      it: 'Repubblica Dominicana',
    },
    name: 'Dominican Republic',
    alpha2Code: 'DO',
    callingCodes: [
      '1809',
      '1829',
      '1849',
    ],
    label: 'República Dominicana',
    value: 'República Dominicana',
  },
  {
    translations: {
      br: 'Equador',
      pt: 'Equador',
      nl: 'Ecuador',
      hr: 'Ekvador',
      fa: 'اکوادور',
      de: 'Ecuador',
      es: 'Ecuador',
      fr: 'Équateur',
      ja: 'エクアドル',
      it: 'Ecuador',
    },
    name: 'Ecuador',
    alpha2Code: 'EC',
    callingCodes: [
      '593',
    ],
    label: 'Equador',
    value: 'Equador',
  },
  {
    translations: {
      br: 'Egito',
      pt: 'Egipto',
      nl: 'Egypte',
      hr: 'Egipat',
      fa: 'مصر',
      de: 'Ägypten',
      es: 'Egipto',
      fr: 'Égypte',
      ja: 'エジプト',
      it: 'Egitto',
    },
    name: 'Egypt',
    alpha2Code: 'EG',
    callingCodes: [
      '20',
    ],
    label: 'Egito',
    value: 'Egito',
  },
  {
    translations: {
      br: 'El Salvador',
      pt: 'El Salvador',
      nl: 'El Salvador',
      hr: 'Salvador',
      fa: 'السالوادور',
      de: 'El Salvador',
      es: 'El Salvador',
      fr: 'Salvador',
      ja: 'エルサルバドル',
      it: 'El Salvador',
    },
    name: 'El Salvador',
    alpha2Code: 'SV',
    callingCodes: [
      '503',
    ],
    label: 'El Salvador',
    value: 'El Salvador',
  },
  {
    translations: {
      br: 'Guiné Equatorial',
      pt: 'Guiné Equatorial',
      nl: 'Equatoriaal-Guinea',
      hr: 'Ekvatorijalna Gvineja',
      fa: 'گینه استوایی',
      de: 'Äquatorial-Guinea',
      es: 'Guinea Ecuatorial',
      fr: 'Guinée-Équatoriale',
      ja: '赤道ギニア',
      it: 'Guinea Equatoriale',
    },
    name: 'Equatorial Guinea',
    alpha2Code: 'GQ',
    callingCodes: [
      '240',
    ],
    label: 'Guiné Equatorial',
    value: 'Guiné Equatorial',
  },
  {
    translations: {
      br: 'Eritreia',
      pt: 'Eritreia',
      nl: 'Eritrea',
      hr: 'Eritreja',
      fa: 'اریتره',
      de: 'Eritrea',
      es: 'Eritrea',
      fr: 'Érythrée',
      ja: 'エリトリア',
      it: 'Eritrea',
    },
    name: 'Eritrea',
    alpha2Code: 'ER',
    callingCodes: [
      '291',
    ],
    label: 'Eritreia',
    value: 'Eritreia',
  },
  {
    translations: {
      br: 'Estônia',
      pt: 'Estónia',
      nl: 'Estland',
      hr: 'Estonija',
      fa: 'استونی',
      de: 'Estland',
      es: 'Estonia',
      fr: 'Estonie',
      ja: 'エストニア',
      it: 'Estonia',
    },
    name: 'Estonia',
    alpha2Code: 'EE',
    callingCodes: [
      '372',
    ],
    label: 'Estônia',
    value: 'Estônia',
  },
  {
    translations: {
      br: 'Etiópia',
      pt: 'Etiópia',
      nl: 'Ethiopië',
      hr: 'Etiopija',
      fa: 'اتیوپی',
      de: 'Äthiopien',
      es: 'Etiopía',
      fr: 'Éthiopie',
      ja: 'エチオピア',
      it: 'Etiopia',
    },
    name: 'Ethiopia',
    alpha2Code: 'ET',
    callingCodes: [
      '251',
    ],
    label: 'Etiópia',
    value: 'Etiópia',
  },
  {
    translations: {
      br: 'Ilhas Malvinas',
      pt: 'Ilhas Falkland',
      nl: 'Falklandeilanden [Islas Malvinas]',
      hr: 'Falklandski Otoci',
      fa: 'جزایر فالکلند',
      de: 'Falklandinseln',
      es: 'Islas Malvinas',
      fr: 'Îles Malouines',
      ja: 'フォークランド（マルビナス）諸島',
      it: 'Isole Falkland o Isole Malvine',
    },
    name: 'Falkland Islands (Malvinas)',
    alpha2Code: 'FK',
    callingCodes: [
      '500',
    ],
    label: 'Ilhas Malvinas',
    value: 'Ilhas Malvinas',
  },
  {
    translations: {
      br: 'Ilhas Faroé',
      pt: 'Ilhas Faroé',
      nl: 'Faeröer',
      hr: 'Farski Otoci',
      fa: 'جزایر فارو',
      de: 'Färöer-Inseln',
      es: 'Islas Faroe',
      fr: 'Îles Féroé',
      ja: 'フェロー諸島',
      it: 'Isole Far Oer',
    },
    name: 'Faroe Islands',
    alpha2Code: 'FO',
    callingCodes: [
      '298',
    ],
    label: 'Ilhas Faroé',
    value: 'Ilhas Faroé',
  },
  {
    translations: {
      br: 'Fiji',
      pt: 'Fiji',
      nl: 'Fiji',
      hr: 'Fiđi',
      fa: 'فیجی',
      de: 'Fidschi',
      es: 'Fiyi',
      fr: 'Fidji',
      ja: 'フィジー',
      it: 'Figi',
    },
    name: 'Fiji',
    alpha2Code: 'FJ',
    callingCodes: [
      '679',
    ],
    label: 'Fiji',
    value: 'Fiji',
  },
  {
    translations: {
      br: 'Finlândia',
      pt: 'Finlândia',
      nl: 'Finland',
      hr: 'Finska',
      fa: 'فنلاند',
      de: 'Finnland',
      es: 'Finlandia',
      fr: 'Finlande',
      ja: 'フィンランド',
      it: 'Finlandia',
    },
    name: 'Finland',
    alpha2Code: 'FI',
    callingCodes: [
      '358',
    ],
    label: 'Finlândia',
    value: 'Finlândia',
  },
  {
    translations: {
      br: 'França',
      pt: 'França',
      nl: 'Frankrijk',
      hr: 'Francuska',
      fa: 'فرانسه',
      de: 'Frankreich',
      es: 'Francia',
      fr: 'France',
      ja: 'フランス',
      it: 'Francia',
    },
    name: 'France',
    alpha2Code: 'FR',
    callingCodes: [
      '33',
    ],
    label: 'França',
    value: 'França',
  },
  {
    translations: {
      br: 'Guiana Francesa',
      pt: 'Guiana Francesa',
      nl: 'Frans-Guyana',
      hr: 'Francuska Gvajana',
      fa: 'گویان فرانسه',
      de: 'Französisch Guyana',
      es: 'Guayana Francesa',
      fr: 'Guayane',
      ja: 'フランス領ギアナ',
      it: 'Guyana francese',
    },
    name: 'French Guiana',
    alpha2Code: 'GF',
    callingCodes: [
      '594',
    ],
    label: 'Guiana Francesa',
    value: 'Guiana Francesa',
  },
  {
    translations: {
      br: 'Polinésia Francesa',
      pt: 'Polinésia Francesa',
      nl: 'Frans-Polynesië',
      hr: 'Francuska Polinezija',
      fa: 'پلی‌نزی فرانسه',
      de: 'Französisch-Polynesien',
      es: 'Polinesia Francesa',
      fr: 'Polynésie française',
      ja: 'フランス領ポリネシア',
      it: 'Polinesia Francese',
    },
    name: 'French Polynesia',
    alpha2Code: 'PF',
    callingCodes: [
      '689',
    ],
    label: 'Polinésia Francesa',
    value: 'Polinésia Francesa',
  },
  {
    translations: {
      br: 'Terras Austrais e Antárticas Francesas',
      pt: 'Terras Austrais e Antárticas Francesas',
      nl: 'Franse Gebieden in de zuidelijke Indische Oceaan',
      hr: 'Francuski južni i antarktički teritoriji',
      fa: 'سرزمین‌های جنوبی و جنوبگانی فرانسه',
      de: 'Französische Süd- und Antarktisgebiete',
      es: 'Tierras Australes y Antárticas Francesas',
      fr: 'Terres australes et antarctiques françaises',
      ja: 'フランス領南方・南極地域',
      it: 'Territori Francesi del Sud',
    },
    name: 'French Southern Territories',
    alpha2Code: 'TF',
    callingCodes: [
      '',
    ],
    label: 'Terras Austrais e Antárticas Francesas',
    value: 'Terras Austrais e Antárticas Francesas',
  },
  {
    translations: {
      br: 'Gabão',
      pt: 'Gabão',
      nl: 'Gabon',
      hr: 'Gabon',
      fa: 'گابن',
      de: 'Gabun',
      es: 'Gabón',
      fr: 'Gabon',
      ja: 'ガボン',
      it: 'Gabon',
    },
    name: 'Gabon',
    alpha2Code: 'GA',
    callingCodes: [
      '241',
    ],
    label: 'Gabão',
    value: 'Gabão',
  },
  {
    translations: {
      br: 'Gâmbia',
      pt: 'Gâmbia',
      nl: 'Gambia',
      hr: 'Gambija',
      fa: 'گامبیا',
      de: 'Gambia',
      es: 'Gambia',
      fr: 'Gambie',
      ja: 'ガンビア',
      it: 'Gambia',
    },
    name: 'Gambia',
    alpha2Code: 'GM',
    callingCodes: [
      '220',
    ],
    label: 'Gâmbia',
    value: 'Gâmbia',
  },
  {
    translations: {
      br: 'Geórgia',
      pt: 'Geórgia',
      nl: 'Georgië',
      hr: 'Gruzija',
      fa: 'گرجستان',
      de: 'Georgien',
      es: 'Georgia',
      fr: 'Géorgie',
      ja: 'グルジア',
      it: 'Georgia',
    },
    name: 'Georgia',
    alpha2Code: 'GE',
    callingCodes: [
      '995',
    ],
    label: 'Geórgia',
    value: 'Geórgia',
  },
  {
    translations: {
      br: 'Alemanha',
      pt: 'Alemanha',
      nl: 'Duitsland',
      hr: 'Njemačka',
      fa: 'آلمان',
      de: 'Deutschland',
      es: 'Alemania',
      fr: 'Allemagne',
      ja: 'ドイツ',
      it: 'Germania',
    },
    name: 'Germany',
    alpha2Code: 'DE',
    callingCodes: [
      '49',
    ],
    label: 'Alemanha',
    value: 'Alemanha',
  },
  {
    translations: {
      br: 'Gana',
      pt: 'Gana',
      nl: 'Ghana',
      hr: 'Gana',
      fa: 'غنا',
      de: 'Ghana',
      es: 'Ghana',
      fr: 'Ghana',
      ja: 'ガーナ',
      it: 'Ghana',
    },
    name: 'Ghana',
    alpha2Code: 'GH',
    callingCodes: [
      '233',
    ],
    label: 'Gana',
    value: 'Gana',
  },
  {
    translations: {
      br: 'Gibraltar',
      pt: 'Gibraltar',
      nl: 'Gibraltar',
      hr: 'Gibraltar',
      fa: 'جبل‌طارق',
      de: 'Gibraltar',
      es: 'Gibraltar',
      fr: 'Gibraltar',
      ja: 'ジブラルタル',
      it: 'Gibilterra',
    },
    name: 'Gibraltar',
    alpha2Code: 'GI',
    callingCodes: [
      '350',
    ],
    label: 'Gibraltar',
    value: 'Gibraltar',
  },
  {
    translations: {
      br: 'Grécia',
      pt: 'Grécia',
      nl: 'Griekenland',
      hr: 'Grčka',
      fa: 'یونان',
      de: 'Griechenland',
      es: 'Grecia',
      fr: 'Grèce',
      ja: 'ギリシャ',
      it: 'Grecia',
    },
    name: 'Greece',
    alpha2Code: 'GR',
    callingCodes: [
      '30',
    ],
    label: 'Grécia',
    value: 'Grécia',
  },
  {
    translations: {
      br: 'Groelândia',
      pt: 'Gronelândia',
      nl: 'Groenland',
      hr: 'Grenland',
      fa: 'گرینلند',
      de: 'Grönland',
      es: 'Groenlandia',
      fr: 'Groenland',
      ja: 'グリーンランド',
      it: 'Groenlandia',
    },
    name: 'Greenland',
    alpha2Code: 'GL',
    callingCodes: [
      '299',
    ],
    label: 'Groelândia',
    value: 'Groelândia',
  },
  {
    translations: {
      br: 'Granada',
      pt: 'Granada',
      nl: 'Grenada',
      hr: 'Grenada',
      fa: 'گرنادا',
      de: 'Grenada',
      es: 'Grenada',
      fr: 'Grenade',
      ja: 'グレナダ',
      it: 'Grenada',
    },
    name: 'Grenada',
    alpha2Code: 'GD',
    callingCodes: [
      '1473',
    ],
    label: 'Granada',
    value: 'Granada',
  },
  {
    translations: {
      br: 'Guadalupe',
      pt: 'Guadalupe',
      nl: 'Guadeloupe',
      hr: 'Gvadalupa',
      fa: 'جزیره گوادلوپ',
      de: 'Guadeloupe',
      es: 'Guadalupe',
      fr: 'Guadeloupe',
      ja: 'グアドループ',
      it: 'Guadeloupa',
    },
    name: 'Guadeloupe',
    alpha2Code: 'GP',
    callingCodes: [
      '590',
    ],
    label: 'Guadalupe',
    value: 'Guadalupe',
  },
  {
    translations: {
      br: 'Guam',
      pt: 'Guame',
      nl: 'Guam',
      hr: 'Guam',
      fa: 'گوام',
      de: 'Guam',
      es: 'Guam',
      fr: 'Guam',
      ja: 'グアム',
      it: 'Guam',
    },
    name: 'Guam',
    alpha2Code: 'GU',
    callingCodes: [
      '1671',
    ],
    label: 'Guam',
    value: 'Guam',
  },
  {
    translations: {
      br: 'Guatemala',
      pt: 'Guatemala',
      nl: 'Guatemala',
      hr: 'Gvatemala',
      fa: 'گواتمالا',
      de: 'Guatemala',
      es: 'Guatemala',
      fr: 'Guatemala',
      ja: 'グアテマラ',
      it: 'Guatemala',
    },
    name: 'Guatemala',
    alpha2Code: 'GT',
    callingCodes: [
      '502',
    ],
    label: 'Guatemala',
    value: 'Guatemala',
  },
  {
    translations: {
      br: 'Guernsey',
      pt: 'Guernsey',
      nl: 'Guernsey',
      hr: 'Guernsey',
      fa: 'گرنزی',
      de: 'Guernsey',
      es: 'Guernsey',
      fr: 'Guernesey',
      ja: 'ガーンジー',
      it: 'Guernsey',
    },
    name: 'Guernsey',
    alpha2Code: 'GG',
    callingCodes: [
      '44',
    ],
    label: 'Guernsey',
    value: 'Guernsey',
  },
  {
    translations: {
      br: 'Guiné',
      pt: 'Guiné',
      nl: 'Guinee',
      hr: 'Gvineja',
      fa: 'گینه',
      de: 'Guinea',
      es: 'Guinea',
      fr: 'Guinée',
      ja: 'ギニア',
      it: 'Guinea',
    },
    name: 'Guinea',
    alpha2Code: 'GN',
    callingCodes: [
      '224',
    ],
    label: 'Guiné',
    value: 'Guiné',
  },
  {
    translations: {
      br: 'Guiné-Bissau',
      pt: 'Guiné-Bissau',
      nl: 'Guinee-Bissau',
      hr: 'Gvineja Bisau',
      fa: 'گینه بیسائو',
      de: 'Guinea-Bissau',
      es: 'Guinea-Bisáu',
      fr: 'Guinée-Bissau',
      ja: 'ギニアビサウ',
      it: 'Guinea-Bissau',
    },
    name: 'Guinea-Bissau',
    alpha2Code: 'GW',
    callingCodes: [
      '245',
    ],
    label: 'Guiné-Bissau',
    value: 'Guiné-Bissau',
  },
  {
    translations: {
      br: 'Guiana',
      pt: 'Guiana',
      nl: 'Guyana',
      hr: 'Gvajana',
      fa: 'گویان',
      de: 'Guyana',
      es: 'Guyana',
      fr: 'Guyane',
      ja: 'ガイアナ',
      it: 'Guyana',
    },
    name: 'Guyana',
    alpha2Code: 'GY',
    callingCodes: [
      '592',
    ],
    label: 'Guiana',
    value: 'Guiana',
  },
  {
    translations: {
      br: 'Haiti',
      pt: 'Haiti',
      nl: 'Haïti',
      hr: 'Haiti',
      fa: 'هائیتی',
      de: 'Haiti',
      es: 'Haiti',
      fr: 'Haïti',
      ja: 'ハイチ',
      it: 'Haiti',
    },
    name: 'Haiti',
    alpha2Code: 'HT',
    callingCodes: [
      '509',
    ],
    label: 'Haiti',
    value: 'Haiti',
  },
  {
    translations: {
      br: 'Ilha Heard e Ilhas McDonald',
      pt: 'Ilha Heard e Ilhas McDonald',
      nl: 'Heard- en McDonaldeilanden',
      hr: 'Otok Heard i otočje McDonald',
      fa: 'جزیره هرد و جزایر مک‌دونالد',
      de: 'Heard und die McDonaldinseln',
      es: 'Islas Heard y McDonald',
      fr: 'Îles Heard-et-MacDonald',
      ja: 'ハード島とマクドナルド諸島',
      it: 'Isole Heard e McDonald',
    },
    name: 'Heard Island and McDonald Islands',
    alpha2Code: 'HM',
    callingCodes: [
      '',
    ],
    label: 'Ilha Heard e Ilhas McDonald',
    value: 'Ilha Heard e Ilhas McDonald',
  },
  {
    translations: {
      br: 'Vaticano',
      pt: 'Vaticano',
      nl: 'Heilige Stoel',
      hr: 'Sveta Stolica',
      fa: 'سریر مقدس',
      de: 'Heiliger Stuhl',
      es: 'Santa Sede',
      fr: 'voir Saint',
      ja: '聖座',
      it: 'Santa Sede',
    },
    name: 'Holy See',
    alpha2Code: 'VA',
    callingCodes: [
      '379',
    ],
    label: 'Vaticano',
    value: 'Vaticano',
  },
  {
    translations: {
      br: 'Honduras',
      pt: 'Honduras',
      nl: 'Honduras',
      hr: 'Honduras',
      fa: 'هندوراس',
      de: 'Honduras',
      es: 'Honduras',
      fr: 'Honduras',
      ja: 'ホンジュラス',
      it: 'Honduras',
    },
    name: 'Honduras',
    alpha2Code: 'HN',
    callingCodes: [
      '504',
    ],
    label: 'Honduras',
    value: 'Honduras',
  },
  {
    translations: {
      br: 'Hong Kong',
      pt: 'Hong Kong',
      nl: 'Hongkong',
      hr: 'Hong Kong',
      fa: 'هنگ‌کنگ',
      de: 'Hong Kong',
      es: 'Hong Kong',
      fr: 'Hong Kong',
      ja: '香港',
      it: 'Hong Kong',
    },
    name: 'Hong Kong',
    alpha2Code: 'HK',
    callingCodes: [
      '852',
    ],
    label: 'Hong Kong',
    value: 'Hong Kong',
  },
  {
    translations: {
      br: 'Hungria',
      pt: 'Hungria',
      nl: 'Hongarije',
      hr: 'Mađarska',
      fa: 'مجارستان',
      de: 'Ungarn',
      es: 'Hungría',
      fr: 'Hongrie',
      ja: 'ハンガリー',
      it: 'Ungheria',
    },
    name: 'Hungary',
    alpha2Code: 'HU',
    callingCodes: [
      '36',
    ],
    label: 'Hungria',
    value: 'Hungria',
  },
  {
    translations: {
      br: 'Islândia',
      pt: 'Islândia',
      nl: 'IJsland',
      hr: 'Island',
      fa: 'ایسلند',
      de: 'Island',
      es: 'Islandia',
      fr: 'Islande',
      ja: 'アイスランド',
      it: 'Islanda',
    },
    name: 'Iceland',
    alpha2Code: 'IS',
    callingCodes: [
      '354',
    ],
    label: 'Islândia',
    value: 'Islândia',
  },
  {
    translations: {
      br: 'Índia',
      pt: 'Índia',
      nl: 'India',
      hr: 'Indija',
      fa: 'هند',
      de: 'Indien',
      es: 'India',
      fr: 'Inde',
      ja: 'インド',
      it: 'India',
    },
    name: 'India',
    alpha2Code: 'IN',
    callingCodes: [
      '91',
    ],
    label: 'Índia',
    value: 'Índia',
  },
  {
    translations: {
      br: 'Indonésia',
      pt: 'Indonésia',
      nl: 'Indonesië',
      hr: 'Indonezija',
      fa: 'اندونزی',
      de: 'Indonesien',
      es: 'Indonesia',
      fr: 'Indonésie',
      ja: 'インドネシア',
      it: 'Indonesia',
    },
    name: 'Indonesia',
    alpha2Code: 'ID',
    callingCodes: [
      '62',
    ],
    label: 'Indonésia',
    value: 'Indonésia',
  },
  {
    translations: {
      br: 'Costa do Marfim',
      pt: 'Costa do Marfim',
      nl: 'Ivoorkust',
      hr: 'Obala Bjelokosti',
      fa: 'ساحل عاج',
      de: 'Elfenbeinküste',
      es: 'Costa de Marfil',
      fr: 'Côte d\'Ivoire',
      ja: 'コートジボワール',
      it: 'Costa D\'Avorio',
    },
    name: 'Côte d\'Ivoire',
    alpha2Code: 'CI',
    callingCodes: [
      '225',
    ],
    label: 'Costa do Marfim',
    value: 'Costa do Marfim',
  },
  {
    translations: {
      br: 'Irã',
      pt: 'Irão',
      nl: 'Iran',
      hr: 'Iran',
      fa: 'ایران',
      de: 'Iran',
      es: 'Iran',
      fr: 'Iran',
      ja: 'イラン・イスラム共和国',
    },
    name: 'Iran (Islamic Republic of)',
    alpha2Code: 'IR',
    callingCodes: [
      '98',
    ],
    label: 'Irã',
    value: 'Irã',
  },
  {
    translations: {
      br: 'Iraque',
      pt: 'Iraque',
      nl: 'Irak',
      hr: 'Irak',
      fa: 'عراق',
      de: 'Irak',
      es: 'Irak',
      fr: 'Irak',
      ja: 'イラク',
      it: 'Iraq',
    },
    name: 'Iraq',
    alpha2Code: 'IQ',
    callingCodes: [
      '964',
    ],
    label: 'Iraque',
    value: 'Iraque',
  },
  {
    translations: {
      br: 'Irlanda',
      pt: 'Irlanda',
      nl: 'Ierland',
      hr: 'Irska',
      fa: 'ایرلند',
      de: 'Irland',
      es: 'Irlanda',
      fr: 'Irlande',
      ja: 'アイルランド',
      it: 'Irlanda',
    },
    name: 'Ireland',
    alpha2Code: 'IE',
    callingCodes: [
      '353',
    ],
    label: 'Irlanda',
    value: 'Irlanda',
  },
  {
    translations: {
      br: 'Ilha de Man',
      pt: 'Ilha de Man',
      nl: 'Isle of Man',
      hr: 'Otok Man',
      fa: 'جزیره من',
      de: 'Insel Man',
      es: 'Isla de Man',
      fr: 'Île de Man',
      ja: 'マン島',
      it: 'Isola di Man',
    },
    name: 'Isle of Man',
    alpha2Code: 'IM',
    callingCodes: [
      '44',
    ],
    label: 'Ilha de Man',
    value: 'Ilha de Man',
  },
  {
    translations: {
      br: 'Israel',
      pt: 'Israel',
      nl: 'Israël',
      hr: 'Izrael',
      fa: 'اسرائیل',
      de: 'Israel',
      es: 'Israel',
      fr: 'Israël',
      ja: 'イスラエル',
      it: 'Israele',
    },
    name: 'Israel',
    alpha2Code: 'IL',
    callingCodes: [
      '972',
    ],
    label: 'Israel',
    value: 'Israel',
  },
  {
    translations: {
      br: 'Itália',
      pt: 'Itália',
      nl: 'Italië',
      hr: 'Italija',
      fa: 'ایتالیا',
      de: 'Italien',
      es: 'Italia',
      fr: 'Italie',
      ja: 'イタリア',
      it: 'Italia',
    },
    name: 'Italy',
    alpha2Code: 'IT',
    callingCodes: [
      '39',
    ],
    label: 'Itália',
    value: 'Itália',
  },
  {
    translations: {
      br: 'Jamaica',
      pt: 'Jamaica',
      nl: 'Jamaica',
      hr: 'Jamajka',
      fa: 'جامائیکا',
      de: 'Jamaika',
      es: 'Jamaica',
      fr: 'Jamaïque',
      ja: 'ジャマイカ',
      it: 'Giamaica',
    },
    name: 'Jamaica',
    alpha2Code: 'JM',
    callingCodes: [
      '1876',
    ],
    label: 'Jamaica',
    value: 'Jamaica',
  },
  {
    translations: {
      br: 'Japão',
      pt: 'Japão',
      nl: 'Japan',
      hr: 'Japan',
      fa: 'ژاپن',
      de: 'Japan',
      es: 'Japón',
      fr: 'Japon',
      ja: '日本',
      it: 'Giappone',
    },
    name: 'Japan',
    alpha2Code: 'JP',
    callingCodes: [
      '81',
    ],
    label: 'Japão',
    value: 'Japão',
  },
  {
    translations: {
      br: 'Jersey',
      pt: 'Jersey',
      nl: 'Jersey',
      hr: 'Jersey',
      fa: 'جرزی',
      de: 'Jersey',
      es: 'Jersey',
      fr: 'Jersey',
      ja: 'ジャージー',
      it: 'Isola di Jersey',
    },
    name: 'Jersey',
    alpha2Code: 'JE',
    callingCodes: [
      '44',
    ],
    label: 'Jersey',
    value: 'Jersey',
  },
  {
    translations: {
      br: 'Jordânia',
      pt: 'Jordânia',
      nl: 'Jordanië',
      hr: 'Jordan',
      fa: 'اردن',
      de: 'Jordanien',
      es: 'Jordania',
      fr: 'Jordanie',
      ja: 'ヨルダン',
      it: 'Giordania',
    },
    name: 'Jordan',
    alpha2Code: 'JO',
    callingCodes: [
      '962',
    ],
    label: 'Jordânia',
    value: 'Jordânia',
  },
  {
    translations: {
      br: 'Cazaquistão',
      pt: 'Cazaquistão',
      nl: 'Kazachstan',
      hr: 'Kazahstan',
      fa: 'قزاقستان',
      de: 'Kasachstan',
      es: 'Kazajistán',
      fr: 'Kazakhstan',
      ja: 'カザフスタン',
      it: 'Kazakistan',
    },
    name: 'Kazakhstan',
    alpha2Code: 'KZ',
    callingCodes: [
      '76',
      '77',
    ],
    label: 'Cazaquistão',
    value: 'Cazaquistão',
  },
  {
    translations: {
      br: 'Quênia',
      pt: 'Quénia',
      nl: 'Kenia',
      hr: 'Kenija',
      fa: 'کنیا',
      de: 'Kenia',
      es: 'Kenia',
      fr: 'Kenya',
      ja: 'ケニア',
      it: 'Kenya',
    },
    name: 'Kenya',
    alpha2Code: 'KE',
    callingCodes: [
      '254',
    ],
    label: 'Quênia',
    value: 'Quênia',
  },
  {
    translations: {
      br: 'Kiribati',
      pt: 'Quiribáti',
      nl: 'Kiribati',
      hr: 'Kiribati',
      fa: 'کیریباتی',
      de: 'Kiribati',
      es: 'Kiribati',
      fr: 'Kiribati',
      ja: 'キリバス',
      it: 'Kiribati',
    },
    name: 'Kiribati',
    alpha2Code: 'KI',
    callingCodes: [
      '686',
    ],
    label: 'Kiribati',
    value: 'Kiribati',
  },
  {
    translations: {
      br: 'Kuwait',
      pt: 'Kuwait',
      nl: 'Koeweit',
      hr: 'Kuvajt',
      fa: 'کویت',
      de: 'Kuwait',
      es: 'Kuwait',
      fr: 'Koweït',
      ja: 'クウェート',
      it: 'Kuwait',
    },
    name: 'Kuwait',
    alpha2Code: 'KW',
    callingCodes: [
      '965',
    ],
    label: 'Kuwait',
    value: 'Kuwait',
  },
  {
    translations: {
      br: 'Quirguistão',
      pt: 'Quirguizistão',
      nl: 'Kirgizië',
      hr: 'Kirgistan',
      fa: 'قرقیزستان',
      de: 'Kirgisistan',
      es: 'Kirguizistán',
      fr: 'Kirghizistan',
      ja: 'キルギス',
      it: 'Kirghizistan',
    },
    name: 'Kyrgyzstan',
    alpha2Code: 'KG',
    callingCodes: [
      '996',
    ],
    label: 'Quirguistão',
    value: 'Quirguistão',
  },
  {
    translations: {
      br: 'Laos',
      pt: 'Laos',
      nl: 'Laos',
      hr: 'Laos',
      fa: 'لائوس',
      de: 'Laos',
      es: 'Laos',
      fr: 'Laos',
      ja: 'ラオス人民民主共和国',
      it: 'Laos',
    },
    name: 'Lao People\'s Democratic Republic',
    alpha2Code: 'LA',
    callingCodes: [
      '856',
    ],
    label: 'Laos',
    value: 'Laos',
  },
  {
    translations: {
      br: 'Letônia',
      pt: 'Letónia',
      nl: 'Letland',
      hr: 'Latvija',
      fa: 'لتونی',
      de: 'Lettland',
      es: 'Letonia',
      fr: 'Lettonie',
      ja: 'ラトビア',
      it: 'Lettonia',
    },
    name: 'Latvia',
    alpha2Code: 'LV',
    callingCodes: [
      '371',
    ],
    label: 'Letônia',
    value: 'Letônia',
  },
  {
    translations: {
      br: 'Líbano',
      pt: 'Líbano',
      nl: 'Libanon',
      hr: 'Libanon',
      fa: 'لبنان',
      de: 'Libanon',
      es: 'Líbano',
      fr: 'Liban',
      ja: 'レバノン',
      it: 'Libano',
    },
    name: 'Lebanon',
    alpha2Code: 'LB',
    callingCodes: [
      '961',
    ],
    label: 'Líbano',
    value: 'Líbano',
  },
  {
    translations: {
      br: 'Lesoto',
      pt: 'Lesoto',
      nl: 'Lesotho',
      hr: 'Lesoto',
      fa: 'لسوتو',
      de: 'Lesotho',
      es: 'Lesotho',
      fr: 'Lesotho',
      ja: 'レソト',
      it: 'Lesotho',
    },
    name: 'Lesotho',
    alpha2Code: 'LS',
    callingCodes: [
      '266',
    ],
    label: 'Lesoto',
    value: 'Lesoto',
  },
  {
    translations: {
      br: 'Libéria',
      pt: 'Libéria',
      nl: 'Liberia',
      hr: 'Liberija',
      fa: 'لیبریا',
      de: 'Liberia',
      es: 'Liberia',
      fr: 'Liberia',
      ja: 'リベリア',
      it: 'Liberia',
    },
    name: 'Liberia',
    alpha2Code: 'LR',
    callingCodes: [
      '231',
    ],
    label: 'Libéria',
    value: 'Libéria',
  },
  {
    translations: {
      br: 'Líbia',
      pt: 'Líbia',
      nl: 'Libië',
      hr: 'Libija',
      fa: 'لیبی',
      de: 'Libyen',
      es: 'Libia',
      fr: 'Libye',
      ja: 'リビア',
      it: 'Libia',
    },
    name: 'Libya',
    alpha2Code: 'LY',
    callingCodes: [
      '218',
    ],
    label: 'Líbia',
    value: 'Líbia',
  },
  {
    translations: {
      br: 'Liechtenstein',
      pt: 'Listenstaine',
      nl: 'Liechtenstein',
      hr: 'Lihtenštajn',
      fa: 'لیختن‌اشتاین',
      de: 'Liechtenstein',
      es: 'Liechtenstein',
      fr: 'Liechtenstein',
      ja: 'リヒテンシュタイン',
      it: 'Liechtenstein',
    },
    name: 'Liechtenstein',
    alpha2Code: 'LI',
    callingCodes: [
      '423',
    ],
    label: 'Liechtenstein',
    value: 'Liechtenstein',
  },
  {
    translations: {
      br: 'Lituânia',
      pt: 'Lituânia',
      nl: 'Litouwen',
      hr: 'Litva',
      fa: 'لیتوانی',
      de: 'Litauen',
      es: 'Lituania',
      fr: 'Lituanie',
      ja: 'リトアニア',
      it: 'Lituania',
    },
    name: 'Lithuania',
    alpha2Code: 'LT',
    callingCodes: [
      '370',
    ],
    label: 'Lituânia',
    value: 'Lituânia',
  },
  {
    translations: {
      br: 'Luxemburgo',
      pt: 'Luxemburgo',
      nl: 'Luxemburg',
      hr: 'Luksemburg',
      fa: 'لوکزامبورگ',
      de: 'Luxemburg',
      es: 'Luxemburgo',
      fr: 'Luxembourg',
      ja: 'ルクセンブルク',
      it: 'Lussemburgo',
    },
    name: 'Luxembourg',
    alpha2Code: 'LU',
    callingCodes: [
      '352',
    ],
    label: 'Luxemburgo',
    value: 'Luxemburgo',
  },
  {
    translations: {
      br: 'Macau',
      pt: 'Macau',
      nl: 'Macao',
      hr: 'Makao',
      fa: 'مکائو',
      de: 'Macao',
      es: 'Macao',
      fr: 'Macao',
      ja: 'マカオ',
      it: 'Macao',
    },
    name: 'Macao',
    alpha2Code: 'MO',
    callingCodes: [
      '853',
    ],
    label: 'Macau',
    value: 'Macau',
  },
  {
    translations: {
      br: 'Macedônia',
      pt: 'Macedónia',
      nl: 'Macedonië',
      hr: 'Makedonija',
      fa: '',
      de: 'Mazedonien',
      es: 'Macedonia',
      fr: 'Macédoine',
      ja: 'マケドニア旧ユーゴスラビア共和国',
      it: 'Macedonia',
    },
    name: 'Macedonia (the former Yugoslav Republic of)',
    alpha2Code: 'MK',
    callingCodes: [
      '389',
    ],
    label: 'Macedônia',
    value: 'Macedônia',
  },
  {
    translations: {
      br: 'Madagascar',
      pt: 'Madagáscar',
      nl: 'Madagaskar',
      hr: 'Madagaskar',
      fa: 'ماداگاسکار',
      de: 'Madagaskar',
      es: 'Madagascar',
      fr: 'Madagascar',
      ja: 'マダガスカル',
      it: 'Madagascar',
    },
    name: 'Madagascar',
    alpha2Code: 'MG',
    callingCodes: [
      '261',
    ],
    label: 'Madagascar',
    value: 'Madagascar',
  },
  {
    translations: {
      br: 'Malawi',
      pt: 'Malávi',
      nl: 'Malawi',
      hr: 'Malavi',
      fa: 'مالاوی',
      de: 'Malawi',
      es: 'Malawi',
      fr: 'Malawi',
      ja: 'マラウイ',
      it: 'Malawi',
    },
    name: 'Malawi',
    alpha2Code: 'MW',
    callingCodes: [
      '265',
    ],
    label: 'Malawi',
    value: 'Malawi',
  },
  {
    translations: {
      br: 'Malásia',
      pt: 'Malásia',
      nl: 'Maleisië',
      hr: 'Malezija',
      fa: 'مالزی',
      de: 'Malaysia',
      es: 'Malasia',
      fr: 'Malaisie',
      ja: 'マレーシア',
      it: 'Malesia',
    },
    name: 'Malaysia',
    alpha2Code: 'MY',
    callingCodes: [
      '60',
    ],
    label: 'Malásia',
    value: 'Malásia',
  },
  {
    translations: {
      br: 'Maldivas',
      pt: 'Maldivas',
      nl: 'Maldiven',
      hr: 'Maldivi',
      fa: 'مالدیو',
      de: 'Malediven',
      es: 'Maldivas',
      fr: 'Maldives',
      ja: 'モルディブ',
      it: 'Maldive',
    },
    name: 'Maldives',
    alpha2Code: 'MV',
    callingCodes: [
      '960',
    ],
    label: 'Maldivas',
    value: 'Maldivas',
  },
  {
    translations: {
      br: 'Mali',
      pt: 'Mali',
      nl: 'Mali',
      hr: 'Mali',
      fa: 'مالی',
      de: 'Mali',
      es: 'Mali',
      fr: 'Mali',
      ja: 'マリ',
      it: 'Mali',
    },
    name: 'Mali',
    alpha2Code: 'ML',
    callingCodes: [
      '223',
    ],
    label: 'Mali',
    value: 'Mali',
  },
  {
    translations: {
      br: 'Malta',
      pt: 'Malta',
      nl: 'Malta',
      hr: 'Malta',
      fa: 'مالت',
      de: 'Malta',
      es: 'Malta',
      fr: 'Malte',
      ja: 'マルタ',
      it: 'Malta',
    },
    name: 'Malta',
    alpha2Code: 'MT',
    callingCodes: [
      '356',
    ],
    label: 'Malta',
    value: 'Malta',
  },
  {
    translations: {
      br: 'Ilhas Marshall',
      pt: 'Ilhas Marshall',
      nl: 'Marshalleilanden',
      hr: 'Maršalovi Otoci',
      fa: 'جزایر مارشال',
      de: 'Marshallinseln',
      es: 'Islas Marshall',
      fr: 'Îles Marshall',
      ja: 'マーシャル諸島',
      it: 'Isole Marshall',
    },
    name: 'Marshall Islands',
    alpha2Code: 'MH',
    callingCodes: [
      '692',
    ],
    label: 'Ilhas Marshall',
    value: 'Ilhas Marshall',
  },
  {
    translations: {
      br: 'Martinica',
      pt: 'Martinica',
      nl: 'Martinique',
      hr: 'Martinique',
      fa: 'مونتسرات',
      de: 'Martinique',
      es: 'Martinica',
      fr: 'Martinique',
      ja: 'マルティニーク',
      it: 'Martinica',
    },
    name: 'Martinique',
    alpha2Code: 'MQ',
    callingCodes: [
      '596',
    ],
    label: 'Martinica',
    value: 'Martinica',
  },
  {
    translations: {
      br: 'Mauritânia',
      pt: 'Mauritânia',
      nl: 'Mauritanië',
      hr: 'Mauritanija',
      fa: 'موریتانی',
      de: 'Mauretanien',
      es: 'Mauritania',
      fr: 'Mauritanie',
      ja: 'モーリタニア',
      it: 'Mauritania',
    },
    name: 'Mauritania',
    alpha2Code: 'MR',
    callingCodes: [
      '222',
    ],
    label: 'Mauritânia',
    value: 'Mauritânia',
  },
  {
    translations: {
      br: 'Maurício',
      pt: 'Maurícia',
      nl: 'Mauritius',
      hr: 'Mauricijus',
      fa: 'موریس',
      de: 'Mauritius',
      es: 'Mauricio',
      fr: 'Île Maurice',
      ja: 'モーリシャス',
      it: 'Mauritius',
    },
    name: 'Mauritius',
    alpha2Code: 'MU',
    callingCodes: [
      '230',
    ],
    label: 'Maurício',
    value: 'Maurício',
  },
  {
    translations: {
      br: 'Mayotte',
      pt: 'Mayotte',
      nl: 'Mayotte',
      hr: 'Mayotte',
      fa: 'مایوت',
      de: 'Mayotte',
      es: 'Mayotte',
      fr: 'Mayotte',
      ja: 'マヨット',
      it: 'Mayotte',
    },
    name: 'Mayotte',
    alpha2Code: 'YT',
    callingCodes: [
      '262',
    ],
    label: 'Mayotte',
    value: 'Mayotte',
  },
  {
    translations: {
      br: 'México',
      pt: 'México',
      nl: 'Mexico',
      hr: 'Meksiko',
      fa: 'مکزیک',
      de: 'Mexiko',
      es: 'México',
      fr: 'Mexique',
      ja: 'メキシコ',
      it: 'Messico',
    },
    name: 'Mexico',
    alpha2Code: 'MX',
    callingCodes: [
      '52',
    ],
    label: 'México',
    value: 'México',
  },
  {
    translations: {
      br: 'Micronésia',
      pt: 'Micronésia',
      nl: 'Micronesië',
      hr: 'Mikronezija',
      fa: 'ایالات فدرال میکرونزی',
      de: 'Mikronesien',
      es: 'Micronesia',
      fr: 'Micronésie',
      ja: 'ミクロネシア連邦',
      it: 'Micronesia',
    },
    name: 'Micronesia (Federated States of)',
    alpha2Code: 'FM',
    callingCodes: [
      '691',
    ],
    label: 'Micronésia',
    value: 'Micronésia',
  },
  {
    translations: {
      br: 'Moldávia',
      pt: 'Moldávia',
      nl: 'Moldavië',
      hr: 'Moldova',
      fa: 'مولداوی',
      de: 'Moldawie',
      es: 'Moldavia',
      fr: 'Moldavie',
      ja: 'モルドバ共和国',
      it: 'Moldavia',
    },
    name: 'Moldova (Republic of)',
    alpha2Code: 'MD',
    callingCodes: [
      '373',
    ],
    label: 'Moldávia',
    value: 'Moldávia',
  },
  {
    translations: {
      br: 'Mônaco',
      pt: 'Mónaco',
      nl: 'Monaco',
      hr: 'Monako',
      fa: 'موناکو',
      de: 'Monaco',
      es: 'Mónaco',
      fr: 'Monaco',
      ja: 'モナコ',
      it: 'Principato di Monaco',
    },
    name: 'Monaco',
    alpha2Code: 'MC',
    callingCodes: [
      '377',
    ],
    label: 'Mônaco',
    value: 'Mônaco',
  },
  {
    translations: {
      br: 'Mongólia',
      pt: 'Mongólia',
      nl: 'Mongolië',
      hr: 'Mongolija',
      fa: 'مغولستان',
      de: 'Mongolei',
      es: 'Mongolia',
      fr: 'Mongolie',
      ja: 'モンゴル',
      it: 'Mongolia',
    },
    name: 'Mongolia',
    alpha2Code: 'MN',
    callingCodes: [
      '976',
    ],
    label: 'Mongólia',
    value: 'Mongólia',
  },
  {
    translations: {
      br: 'Montenegro',
      pt: 'Montenegro',
      nl: 'Montenegro',
      hr: 'Crna Gora',
      fa: 'مونته‌نگرو',
      de: 'Montenegro',
      es: 'Montenegro',
      fr: 'Monténégro',
      ja: 'モンテネグロ',
      it: 'Montenegro',
    },
    name: 'Montenegro',
    alpha2Code: 'ME',
    callingCodes: [
      '382',
    ],
    label: 'Montenegro',
    value: 'Montenegro',
  },
  {
    translations: {
      br: 'Montserrat',
      pt: 'Monserrate',
      nl: 'Montserrat',
      hr: 'Montserrat',
      fa: 'مایوت',
      de: 'Montserrat',
      es: 'Montserrat',
      fr: 'Montserrat',
      ja: 'モントセラト',
      it: 'Montserrat',
    },
    name: 'Montserrat',
    alpha2Code: 'MS',
    callingCodes: [
      '1664',
    ],
    label: 'Montserrat',
    value: 'Montserrat',
  },
  {
    translations: {
      br: 'Marrocos',
      pt: 'Marrocos',
      nl: 'Marokko',
      hr: 'Maroko',
      fa: 'مراکش',
      de: 'Marokko',
      es: 'Marruecos',
      fr: 'Maroc',
      ja: 'モロッコ',
      it: 'Marocco',
    },
    name: 'Morocco',
    alpha2Code: 'MA',
    callingCodes: [
      '212',
    ],
    label: 'Marrocos',
    value: 'Marrocos',
  },
  {
    translations: {
      br: 'Moçambique',
      pt: 'Moçambique',
      nl: 'Mozambique',
      hr: 'Mozambik',
      fa: 'موزامبیک',
      de: 'Mosambik',
      es: 'Mozambique',
      fr: 'Mozambique',
      ja: 'モザンビーク',
      it: 'Mozambico',
    },
    name: 'Mozambique',
    alpha2Code: 'MZ',
    callingCodes: [
      '258',
    ],
    label: 'Moçambique',
    value: 'Moçambique',
  },
  {
    translations: {
      br: 'Myanmar',
      pt: 'Myanmar',
      nl: 'Myanmar',
      hr: 'Mijanmar',
      fa: 'میانمار',
      de: 'Myanmar',
      es: 'Myanmar',
      fr: 'Myanmar',
      ja: 'ミャンマー',
      it: 'Birmania',
    },
    name: 'Myanmar',
    alpha2Code: 'MM',
    callingCodes: [
      '95',
    ],
    label: 'Myanmar',
    value: 'Myanmar',
  },
  {
    translations: {
      br: 'Namíbia',
      pt: 'Namíbia',
      nl: 'Namibië',
      hr: 'Namibija',
      fa: 'نامیبیا',
      de: 'Namibia',
      es: 'Namibia',
      fr: 'Namibie',
      ja: 'ナミビア',
      it: 'Namibia',
    },
    name: 'Namibia',
    alpha2Code: 'NA',
    callingCodes: [
      '264',
    ],
    label: 'Namíbia',
    value: 'Namíbia',
  },
  {
    translations: {
      br: 'Nauru',
      pt: 'Nauru',
      nl: 'Nauru',
      hr: 'Nauru',
      fa: 'نائورو',
      de: 'Nauru',
      es: 'Nauru',
      fr: 'Nauru',
      ja: 'ナウル',
      it: 'Nauru',
    },
    name: 'Nauru',
    alpha2Code: 'NR',
    callingCodes: [
      '674',
    ],
    label: 'Nauru',
    value: 'Nauru',
  },
  {
    translations: {
      br: 'Nepal',
      pt: 'Nepal',
      nl: 'Nepal',
      hr: 'Nepal',
      fa: 'نپال',
      de: 'Népal',
      es: 'Nepal',
      fr: 'Népal',
      ja: 'ネパール',
      it: 'Nepal',
    },
    name: 'Nepal',
    alpha2Code: 'NP',
    callingCodes: [
      '977',
    ],
    label: 'Nepal',
    value: 'Nepal',
  },
  {
    translations: {
      br: 'Holanda',
      pt: 'Países Baixos',
      nl: 'Nederland',
      hr: 'Nizozemska',
      fa: 'پادشاهی هلند',
      de: 'Niederlande',
      es: 'Países Bajos',
      fr: 'Pays-Bas',
      ja: 'オランダ',
      it: 'Paesi Bassi',
    },
    name: 'Netherlands',
    alpha2Code: 'NL',
    callingCodes: [
      '31',
    ],
    label: 'Holanda',
    value: 'Holanda',
  },
  {
    translations: {
      br: 'Nova Caledônia',
      pt: 'Nova Caledónia',
      nl: 'Nieuw-Caledonië',
      hr: 'Nova Kaledonija',
      fa: 'کالدونیای جدید',
      de: 'Neukaledonien',
      es: 'Nueva Caledonia',
      fr: 'Nouvelle-Calédonie',
      ja: 'ニューカレドニア',
      it: 'Nuova Caledonia',
    },
    name: 'New Caledonia',
    alpha2Code: 'NC',
    callingCodes: [
      '687',
    ],
    label: 'Nova Caledônia',
    value: 'Nova Caledônia',
  },
  {
    translations: {
      br: 'Nova Zelândia',
      pt: 'Nova Zelândia',
      nl: 'Nieuw-Zeeland',
      hr: 'Novi Zeland',
      fa: 'نیوزیلند',
      de: 'Neuseeland',
      es: 'Nueva Zelanda',
      fr: 'Nouvelle-Zélande',
      ja: 'ニュージーランド',
      it: 'Nuova Zelanda',
    },
    name: 'New Zealand',
    alpha2Code: 'NZ',
    callingCodes: [
      '64',
    ],
    label: 'Nova Zelândia',
    value: 'Nova Zelândia',
  },
  {
    translations: {
      br: 'Nicarágua',
      pt: 'Nicarágua',
      nl: 'Nicaragua',
      hr: 'Nikaragva',
      fa: 'نیکاراگوئه',
      de: 'Nicaragua',
      es: 'Nicaragua',
      fr: 'Nicaragua',
      ja: 'ニカラグア',
      it: 'Nicaragua',
    },
    name: 'Nicaragua',
    alpha2Code: 'NI',
    callingCodes: [
      '505',
    ],
    label: 'Nicarágua',
    value: 'Nicarágua',
  },
  {
    translations: {
      br: 'Níger',
      pt: 'Níger',
      nl: 'Niger',
      hr: 'Niger',
      fa: 'نیجر',
      de: 'Niger',
      es: 'Níger',
      fr: 'Niger',
      ja: 'ニジェール',
      it: 'Niger',
    },
    name: 'Niger',
    alpha2Code: 'NE',
    callingCodes: [
      '227',
    ],
    label: 'Níger',
    value: 'Níger',
  },
  {
    translations: {
      br: 'Nigéria',
      pt: 'Nigéria',
      nl: 'Nigeria',
      hr: 'Nigerija',
      fa: 'نیجریه',
      de: 'Nigeria',
      es: 'Nigeria',
      fr: 'Nigéria',
      ja: 'ナイジェリア',
      it: 'Nigeria',
    },
    name: 'Nigeria',
    alpha2Code: 'NG',
    callingCodes: [
      '234',
    ],
    label: 'Nigéria',
    value: 'Nigéria',
  },
  {
    translations: {
      br: 'Niue',
      pt: 'Niue',
      nl: 'Niue',
      hr: 'Niue',
      fa: 'نیووی',
      de: 'Niue',
      es: 'Niue',
      fr: 'Niue',
      ja: 'ニウエ',
      it: 'Niue',
    },
    name: 'Niue',
    alpha2Code: 'NU',
    callingCodes: [
      '683',
    ],
    label: 'Niue',
    value: 'Niue',
  },
  {
    translations: {
      br: 'Ilha Norfolk',
      pt: 'Ilha Norfolk',
      nl: 'Norfolkeiland',
      hr: 'Otok Norfolk',
      fa: 'جزیره نورفک',
      de: 'Norfolkinsel',
      es: 'Isla de Norfolk',
      fr: 'Île de Norfolk',
      ja: 'ノーフォーク島',
      it: 'Isola Norfolk',
    },
    name: 'Norfolk Island',
    alpha2Code: 'NF',
    callingCodes: [
      '672',
    ],
    label: 'Ilha Norfolk',
    value: 'Ilha Norfolk',
  },
  {
    translations: {
      br: 'Coreia do Norte',
      pt: 'Coreia do Norte',
      nl: 'Noord-Korea',
      hr: 'Sjeverna Koreja',
      fa: 'کره جنوبی',
      de: 'Nordkorea',
      es: 'Corea del Norte',
      fr: 'Corée du Nord',
      ja: '朝鮮民主主義人民共和国',
      it: 'Corea del Nord',
    },
    name: 'Korea (Democratic People\'s Republic of)',
    alpha2Code: 'KP',
    callingCodes: [
      '850',
    ],
    label: 'Coreia do Norte',
    value: 'Coreia do Norte',
  },
  {
    translations: {
      br: 'Ilhas Marianas',
      pt: 'Ilhas Marianas',
      nl: 'Noordelijke Marianeneilanden',
      hr: 'Sjevernomarijanski otoci',
      fa: 'جزایر ماریانای شمالی',
      de: 'Nördliche Marianen',
      es: 'Islas Marianas del Norte',
      fr: 'Îles Mariannes du Nord',
      ja: '北マリアナ諸島',
      it: 'Isole Marianne Settentrionali',
    },
    name: 'Northern Mariana Islands',
    alpha2Code: 'MP',
    callingCodes: [
      '1670',
    ],
    label: 'Ilhas Marianas',
    value: 'Ilhas Marianas',
  },
  {
    translations: {
      br: 'Noruega',
      pt: 'Noruega',
      nl: 'Noorwegen',
      hr: 'Norveška',
      fa: 'نروژ',
      de: 'Norwegen',
      es: 'Noruega',
      fr: 'Norvège',
      ja: 'ノルウェー',
      it: 'Norvegia',
    },
    name: 'Norway',
    alpha2Code: 'NO',
    callingCodes: [
      '47',
    ],
    label: 'Noruega',
    value: 'Noruega',
  },
  {
    translations: {
      br: 'Omã',
      pt: 'Omã',
      nl: 'Oman',
      hr: 'Oman',
      fa: 'عمان',
      de: 'Oman',
      es: 'Omán',
      fr: 'Oman',
      ja: 'オマーン',
      it: 'oman',
    },
    name: 'Oman',
    alpha2Code: 'OM',
    callingCodes: [
      '968',
    ],
    label: 'Omã',
    value: 'Omã',
  },
  {
    translations: {
      br: 'Paquistão',
      pt: 'Paquistão',
      nl: 'Pakistan',
      hr: 'Pakistan',
      fa: 'پاکستان',
      de: 'Pakistan',
      es: 'Pakistán',
      fr: 'Pakistan',
      ja: 'パキスタン',
      it: 'Pakistan',
    },
    name: 'Pakistan',
    alpha2Code: 'PK',
    callingCodes: [
      '92',
    ],
    label: 'Paquistão',
    value: 'Paquistão',
  },
  {
    translations: {
      br: 'Palau',
      pt: 'Palau',
      nl: 'Palau',
      hr: 'Palau',
      fa: 'پالائو',
      de: 'Palau',
      es: 'Palau',
      fr: 'Palaos',
      ja: 'パラオ',
      it: 'Palau',
    },
    name: 'Palau',
    alpha2Code: 'PW',
    callingCodes: [
      '680',
    ],
    label: 'Palau',
    value: 'Palau',
  },
  {
    translations: {
      br: 'Palestina',
      pt: 'Palestina',
      nl: 'Palestijnse gebieden',
      hr: 'Palestina',
      fa: 'فلسطین',
      de: 'Palästina',
      es: 'Palestina',
      fr: 'Palestine',
      ja: 'パレスチナ',
      it: 'Palestina',
    },
    name: 'Palestine, State of',
    alpha2Code: 'PS',
    callingCodes: [
      '970',
    ],
    label: 'Palestina',
    value: 'Palestina',
  },
  {
    translations: {
      br: 'Panamá',
      pt: 'Panamá',
      nl: 'Panama',
      hr: 'Panama',
      fa: 'پاناما',
      de: 'Panama',
      es: 'Panamá',
      fr: 'Panama',
      ja: 'パナマ',
      it: 'Panama',
    },
    name: 'Panama',
    alpha2Code: 'PA',
    callingCodes: [
      '507',
    ],
    label: 'Panamá',
    value: 'Panamá',
  },
  {
    translations: {
      br: 'Papua Nova Guiné',
      pt: 'Papua Nova Guiné',
      nl: 'Papoea-Nieuw-Guinea',
      hr: 'Papua Nova Gvineja',
      fa: 'پاپوآ گینه نو',
      de: 'Papua-Neuguinea',
      es: 'Papúa Nueva Guinea',
      fr: 'Papouasie-Nouvelle-Guinée',
      ja: 'パプアニューギニア',
      it: 'Papua Nuova Guinea',
    },
    name: 'Papua New Guinea',
    alpha2Code: 'PG',
    callingCodes: [
      '675',
    ],
    label: 'Papua Nova Guiné',
    value: 'Papua Nova Guiné',
  },
  {
    translations: {
      br: 'Paraguai',
      pt: 'Paraguai',
      nl: 'Paraguay',
      hr: 'Paragvaj',
      fa: 'پاراگوئه',
      de: 'Paraguay',
      es: 'Paraguay',
      fr: 'Paraguay',
      ja: 'パラグアイ',
      it: 'Paraguay',
    },
    name: 'Paraguay',
    alpha2Code: 'PY',
    callingCodes: [
      '595',
    ],
    label: 'Paraguai',
    value: 'Paraguai',
  },
  {
    translations: {
      br: 'Peru',
      pt: 'Peru',
      nl: 'Peru',
      hr: 'Peru',
      fa: 'پرو',
      de: 'Peru',
      es: 'Perú',
      fr: 'Pérou',
      ja: 'ペルー',
      it: 'Perù',
    },
    name: 'Peru',
    alpha2Code: 'PE',
    callingCodes: [
      '51',
    ],
    label: 'Peru',
    value: 'Peru',
  },
  {
    translations: {
      br: 'Filipinas',
      pt: 'Filipinas',
      nl: 'Filipijnen',
      hr: 'Filipini',
      fa: 'جزایر الندفیلیپین',
      de: 'Philippinen',
      es: 'Filipinas',
      fr: 'Philippines',
      ja: 'フィリピン',
      it: 'Filippine',
    },
    name: 'Philippines',
    alpha2Code: 'PH',
    callingCodes: [
      '63',
    ],
    label: 'Filipinas',
    value: 'Filipinas',
  },
  {
    translations: {
      br: 'Ilhas Pitcairn',
      pt: 'Ilhas Picárnia',
      nl: 'Pitcairneilanden',
      hr: 'Pitcairnovo otočje',
      fa: 'پیتکرن',
      de: 'Pitcairn',
      es: 'Islas Pitcairn',
      fr: 'Îles Pitcairn',
      ja: 'ピトケアン',
      it: 'Isole Pitcairn',
    },
    name: 'Pitcairn',
    alpha2Code: 'PN',
    callingCodes: [
      '64',
    ],
    label: 'Ilhas Pitcairn',
    value: 'Ilhas Pitcairn',
  },
  {
    translations: {
      br: 'Polônia',
      pt: 'Polónia',
      nl: 'Polen',
      hr: 'Poljska',
      fa: 'لهستان',
      de: 'Polen',
      es: 'Polonia',
      fr: 'Pologne',
      ja: 'ポーランド',
      it: 'Polonia',
    },
    name: 'Poland',
    alpha2Code: 'PL',
    callingCodes: [
      '48',
    ],
    label: 'Polônia',
    value: 'Polônia',
  },
  {
    translations: {
      br: 'Porto Rico',
      pt: 'Porto Rico',
      nl: 'Puerto Rico',
      hr: 'Portoriko',
      fa: 'پورتو ریکو',
      de: 'Puerto Rico',
      es: 'Puerto Rico',
      fr: 'Porto Rico',
      ja: 'プエルトリコ',
      it: 'Porto Rico',
    },
    name: 'Puerto Rico',
    alpha2Code: 'PR',
    callingCodes: [
      '1787',
      '1939',
    ],
    label: 'Porto Rico',
    value: 'Porto Rico',
  },
  {
    translations: {
      br: 'Catar',
      pt: 'Catar',
      nl: 'Qatar',
      hr: 'Katar',
      fa: 'قطر',
      de: 'Katar',
      es: 'Catar',
      fr: 'Qatar',
      ja: 'カタール',
      it: 'Qatar',
    },
    name: 'Qatar',
    alpha2Code: 'QA',
    callingCodes: [
      '974',
    ],
    label: 'Catar',
    value: 'Catar',
  },
  {
    translations: {
      br: 'Kosovo',
      pt: 'Kosovo',
      hr: 'Kosovo',
      fa: 'کوزوو',
      es: 'Kosovo',
    },
    name: 'Republic of Kosovo',
    alpha2Code: 'XK',
    callingCodes: [
      '383',
    ],
    label: 'Kosovo',
    value: 'Kosovo',
  },
  {
    translations: {
      br: 'Reunião',
      pt: 'Reunião',
      nl: 'Réunion',
      hr: 'Réunion',
      fa: 'رئونیون',
      de: 'Réunion',
      es: 'Reunión',
      fr: 'Réunion',
      ja: 'レユニオン',
      it: 'Riunione',
    },
    name: 'Réunion',
    alpha2Code: 'RE',
    callingCodes: [
      '262',
    ],
    label: 'Reunião',
    value: 'Reunião',
  },
  {
    translations: {
      br: 'Romênia',
      pt: 'Roménia',
      nl: 'Roemenië',
      hr: 'Rumunjska',
      fa: 'رومانی',
      de: 'Rumänien',
      es: 'Rumania',
      fr: 'Roumanie',
      ja: 'ルーマニア',
      it: 'Romania',
    },
    name: 'Romania',
    alpha2Code: 'RO',
    callingCodes: [
      '40',
    ],
    label: 'Romênia',
    value: 'Romênia',
  },
  {
    translations: {
      br: 'Rússia',
      pt: 'Rússia',
      nl: 'Rusland',
      hr: 'Rusija',
      fa: 'روسیه',
      de: 'Russland',
      es: 'Rusia',
      fr: 'Russie',
      ja: 'ロシア連邦',
      it: 'Russia',
    },
    name: 'Russian Federation',
    alpha2Code: 'RU',
    callingCodes: [
      '7',
    ],
    label: 'Rússia',
    value: 'Rússia',
  },
  {
    translations: {
      br: 'Ruanda',
      pt: 'Ruanda',
      nl: 'Rwanda',
      hr: 'Ruanda',
      fa: 'رواندا',
      de: 'Ruanda',
      es: 'Ruanda',
      fr: 'Rwanda',
      ja: 'ルワンダ',
      it: 'Ruanda',
    },
    name: 'Rwanda',
    alpha2Code: 'RW',
    callingCodes: [
      '250',
    ],
    label: 'Ruanda',
    value: 'Ruanda',
  },
  {
    translations: {
      br: 'São Bartolomeu',
      pt: 'São Bartolomeu',
      nl: 'Saint Barthélemy',
      hr: 'Saint Barthélemy',
      fa: 'سن-بارتلمی',
      de: 'Saint-Barthélemy',
      es: 'San Bartolomé',
      fr: 'Saint-Barthélemy',
      ja: 'サン・バルテルミー',
      it: 'Antille Francesi',
    },
    name: 'Saint Barthélemy',
    alpha2Code: 'BL',
    callingCodes: [
      '590',
    ],
    label: 'São Bartolomeu',
    value: 'São Bartolomeu',
  },
  {
    translations: {
      br: 'Santa Helena',
      pt: 'Santa Helena',
      nl: 'Sint-Helena',
      hr: 'Sveta Helena',
      fa: 'سنت هلنا، اسنشن و تریستان دا کونا',
      de: 'Sankt Helena',
      es: 'Santa Helena',
      fr: 'Sainte-Hélène',
      ja: 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
      it: 'Sant\'Elena',
    },
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha2Code: 'SH',
    callingCodes: [
      '290',
    ],
    label: 'Santa Helena',
    value: 'Santa Helena',
  },
  {
    translations: {
      br: 'São Cristóvão e Neves',
      pt: 'São Cristóvão e Neves',
      nl: 'Saint Kitts en Nevis',
      hr: 'Sveti Kristof i Nevis',
      fa: 'سنت کیتس و نویس',
      de: 'St. Kitts und Nevis',
      es: 'San Cristóbal y Nieves',
      fr: 'Saint-Christophe-et-Niévès',
      ja: 'セントクリストファー・ネイビス',
      it: 'Saint Kitts e Nevis',
    },
    name: 'Saint Kitts and Nevis',
    alpha2Code: 'KN',
    callingCodes: [
      '1869',
    ],
    label: 'São Cristóvão e Neves',
    value: 'São Cristóvão e Neves',
  },
  {
    translations: {
      br: 'Santa Lúcia',
      pt: 'Santa Lúcia',
      nl: 'Saint Lucia',
      hr: 'Sveta Lucija',
      fa: 'سنت لوسیا',
      de: 'Saint Lucia',
      es: 'Santa Lucía',
      fr: 'Saint-Lucie',
      ja: 'セントルシア',
      it: 'Santa Lucia',
    },
    name: 'Saint Lucia',
    alpha2Code: 'LC',
    callingCodes: [
      '1758',
    ],
    label: 'Santa Lúcia',
    value: 'Santa Lúcia',
  },
  {
    translations: {
      br: 'Saint Martin',
      pt: 'Ilha São Martinho',
      nl: 'Saint-Martin',
      hr: 'Sveti Martin',
      fa: 'سینت مارتن',
      de: 'Saint Martin',
      es: 'Saint Martin',
      fr: 'Saint-Martin',
      ja: 'サン・マルタン（フランス領）',
      it: 'Saint Martin',
    },
    name: 'Saint Martin (French part)',
    alpha2Code: 'MF',
    callingCodes: [
      '590',
    ],
    label: 'Saint Martin',
    value: 'Saint Martin',
  },
  {
    translations: {
      br: 'Saint-Pierre e Miquelon',
      pt: 'São Pedro e Miquelon',
      nl: 'Saint Pierre en Miquelon',
      hr: 'Sveti Petar i Mikelon',
      fa: 'سن پیر و میکلن',
      de: 'Saint-Pierre und Miquelon',
      es: 'San Pedro y Miquelón',
      fr: 'Saint-Pierre-et-Miquelon',
      ja: 'サンピエール島・ミクロン島',
      it: 'Saint-Pierre e Miquelon',
    },
    name: 'Saint Pierre and Miquelon',
    alpha2Code: 'PM',
    callingCodes: [
      '508',
    ],
    label: 'Saint-Pierre e Miquelon',
    value: 'Saint-Pierre e Miquelon',
  },
  {
    translations: {
      br: 'São Vicente e Granadinas',
      pt: 'São Vicente e Granadinas',
      nl: 'Saint Vincent en de Grenadines',
      hr: 'Sveti Vincent i Grenadini',
      fa: 'سنت وینسنت و گرنادین‌ها',
      de: 'Saint Vincent und die Grenadinen',
      es: 'San Vicente y Granadinas',
      fr: 'Saint-Vincent-et-les-Grenadines',
      ja: 'セントビンセントおよびグレナディーン諸島',
      it: 'Saint Vincent e Grenadine',
    },
    name: 'Saint Vincent and the Grenadines',
    alpha2Code: 'VC',
    callingCodes: [
      '1784',
    ],
    label: 'São Vicente e Granadinas',
    value: 'São Vicente e Granadinas',
  },
  {
    translations: {
      br: 'Samoa',
      pt: 'Samoa',
      nl: 'Samoa',
      hr: 'Samoa',
      fa: 'ساموآ',
      de: 'Samoa',
      es: 'Samoa',
      fr: 'Samoa',
      ja: 'サモア',
      it: 'Samoa',
    },
    name: 'Samoa',
    alpha2Code: 'WS',
    callingCodes: [
      '685',
    ],
    label: 'Samoa',
    value: 'Samoa',
  },
  {
    translations: {
      br: 'San Marino',
      pt: 'São Marinho',
      nl: 'San Marino',
      hr: 'San Marino',
      fa: 'سان مارینو',
      de: 'San Marino',
      es: 'San Marino',
      fr: 'Saint-Marin',
      ja: 'サンマリノ',
      it: 'San Marino',
    },
    name: 'San Marino',
    alpha2Code: 'SM',
    callingCodes: [
      '378',
    ],
    label: 'San Marino',
    value: 'San Marino',
  },
  {
    translations: {
      br: 'São Tomé e Príncipe',
      pt: 'São Tomé e Príncipe',
      nl: 'Sao Tomé en Principe',
      hr: 'Sveti Toma i Princip',
      fa: 'کواترو دو فرویرو',
      de: 'São Tomé und Príncipe',
      es: 'Santo Tomé y Príncipe',
      fr: 'Sao Tomé-et-Principe',
      ja: 'サントメ・プリンシペ',
      it: 'São Tomé e Príncipe',
    },
    name: 'Sao Tome and Principe',
    alpha2Code: 'ST',
    callingCodes: [
      '239',
    ],
    label: 'São Tomé e Príncipe',
    value: 'São Tomé e Príncipe',
  },
  {
    translations: {
      br: 'Arábia Saudita',
      pt: 'Arábia Saudita',
      nl: 'Saoedi-Arabië',
      hr: 'Saudijska Arabija',
      fa: 'عربستان سعودی',
      de: 'Saudi-Arabien',
      es: 'Arabia Saudí',
      fr: 'Arabie Saoudite',
      ja: 'サウジアラビア',
      it: 'Arabia Saudita',
    },
    name: 'Saudi Arabia',
    alpha2Code: 'SA',
    callingCodes: [
      '966',
    ],
    label: 'Arábia Saudita',
    value: 'Arábia Saudita',
  },
  {
    translations: {
      br: 'Senegal',
      pt: 'Senegal',
      nl: 'Senegal',
      hr: 'Senegal',
      fa: 'سنگال',
      de: 'Senegal',
      es: 'Senegal',
      fr: 'Sénégal',
      ja: 'セネガル',
      it: 'Senegal',
    },
    name: 'Senegal',
    alpha2Code: 'SN',
    callingCodes: [
      '221',
    ],
    label: 'Senegal',
    value: 'Senegal',
  },
  {
    translations: {
      br: 'Sérvia',
      pt: 'Sérvia',
      nl: 'Servië',
      hr: 'Srbija',
      fa: 'صربستان',
      de: 'Serbien',
      es: 'Serbia',
      fr: 'Serbie',
      ja: 'セルビア',
      it: 'Serbia',
    },
    name: 'Serbia',
    alpha2Code: 'RS',
    callingCodes: [
      '381',
    ],
    label: 'Sérvia',
    value: 'Sérvia',
  },
  {
    translations: {
      br: 'Seicheles',
      pt: 'Seicheles',
      nl: 'Seychellen',
      hr: 'Sejšeli',
      fa: 'سیشل',
      de: 'Seychellen',
      es: 'Seychelles',
      fr: 'Seychelles',
      ja: 'セーシェル',
      it: 'Seychelles',
    },
    name: 'Seychelles',
    alpha2Code: 'SC',
    callingCodes: [
      '248',
    ],
    label: 'Seicheles',
    value: 'Seicheles',
  },
  {
    translations: {
      br: 'Serra Leoa',
      pt: 'Serra Leoa',
      nl: 'Sierra Leone',
      hr: 'Sijera Leone',
      fa: 'سیرالئون',
      de: 'Sierra Leone',
      es: 'Sierra Leone',
      fr: 'Sierra Leone',
      ja: 'シエラレオネ',
      it: 'Sierra Leone',
    },
    name: 'Sierra Leone',
    alpha2Code: 'SL',
    callingCodes: [
      '232',
    ],
    label: 'Serra Leoa',
    value: 'Serra Leoa',
  },
  {
    translations: {
      br: 'Singapura',
      pt: 'Singapura',
      nl: 'Singapore',
      hr: 'Singapur',
      fa: 'سنگاپور',
      de: 'Singapur',
      es: 'Singapur',
      fr: 'Singapour',
      ja: 'シンガポール',
      it: 'Singapore',
    },
    name: 'Singapore',
    alpha2Code: 'SG',
    callingCodes: [
      '65',
    ],
    label: 'Singapura',
    value: 'Singapura',
  },
  {
    translations: {
      br: 'Sint Maarten',
      pt: 'São Martinho',
      nl: 'Sint Maarten',
      fa: 'سینت مارتن',
      de: 'Sint Maarten (niederl. Teil)',
      fr: 'Saint Martin (partie néerlandaise)',
      it: 'Saint Martin (parte olandese)',
    },
    name: 'Sint Maarten (Dutch part)',
    alpha2Code: 'SX',
    callingCodes: [
      '1721',
    ],
    label: 'Sint Maarten',
    value: 'Sint Maarten',
  },
  {
    translations: {
      br: 'Eslováquia',
      pt: 'Eslováquia',
      nl: 'Slowakije',
      hr: 'Slovačka',
      fa: 'اسلواکی',
      de: 'Slowakei',
      es: 'República Eslovaca',
      fr: 'Slovaquie',
      ja: 'スロバキア',
      it: 'Slovacchia',
    },
    name: 'Slovakia',
    alpha2Code: 'SK',
    callingCodes: [
      '421',
    ],
    label: 'Eslováquia',
    value: 'Eslováquia',
  },
  {
    translations: {
      br: 'Eslovênia',
      pt: 'Eslovénia',
      nl: 'Slovenië',
      hr: 'Slovenija',
      fa: 'اسلوونی',
      de: 'Slowenien',
      es: 'Eslovenia',
      fr: 'Slovénie',
      ja: 'スロベニア',
      it: 'Slovenia',
    },
    name: 'Slovenia',
    alpha2Code: 'SI',
    callingCodes: [
      '386',
    ],
    label: 'Eslovênia',
    value: 'Eslovênia',
  },
  {
    translations: {
      br: 'Ilhas Salomão',
      pt: 'Ilhas Salomão',
      nl: 'Salomonseilanden',
      hr: 'Solomonski Otoci',
      fa: 'جزایر سلیمان',
      de: 'Salomonen',
      es: 'Islas Salomón',
      fr: 'Îles Salomon',
      ja: 'ソロモン諸島',
      it: 'Isole Salomone',
    },
    name: 'Solomon Islands',
    alpha2Code: 'SB',
    callingCodes: [
      '677',
    ],
    label: 'Ilhas Salomão',
    value: 'Ilhas Salomão',
  },
  {
    translations: {
      br: 'Somália',
      pt: 'Somália',
      nl: 'Somalië',
      hr: 'Somalija',
      fa: 'سومالی',
      de: 'Somalia',
      es: 'Somalia',
      fr: 'Somalie',
      ja: 'ソマリア',
      it: 'Somalia',
    },
    name: 'Somalia',
    alpha2Code: 'SO',
    callingCodes: [
      '252',
    ],
    label: 'Somália',
    value: 'Somália',
  },
  {
    translations: {
      br: 'República Sul-Africana',
      pt: 'República Sul-Africana',
      nl: 'Zuid-Afrika',
      hr: 'Južnoafrička Republika',
      fa: 'آفریقای جنوبی',
      de: 'Republik Südafrika',
      es: 'República de Sudáfrica',
      fr: 'Afrique du Sud',
      ja: '南アフリカ',
      it: 'Sud Africa',
    },
    name: 'South Africa',
    alpha2Code: 'ZA',
    callingCodes: [
      '27',
    ],
    label: 'República Sul-Africana',
    value: 'República Sul-Africana',
  },
  {
    translations: {
      br: 'Ilhas Geórgias do Sul e Sandwich do Sul',
      pt: 'Ilhas Geórgia do Sul e Sanduíche do Sul',
      nl: 'Zuid-Georgia en Zuidelijke Sandwicheilanden',
      hr: 'Južna Georgija i otočje Južni Sandwich',
      fa: 'جزایر جورجیای جنوبی و ساندویچ جنوبی',
      de: 'Südgeorgien und die Südlichen Sandwichinseln',
      es: 'Islas Georgias del Sur y Sandwich del Sur',
      fr: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
      ja: 'サウスジョージア・サウスサンドウィッチ諸島',
      it: 'Georgia del Sud e Isole Sandwich Meridionali',
    },
    name: 'South Georgia and the South Sandwich Islands',
    alpha2Code: 'GS',
    callingCodes: [
      '500',
    ],
    label: 'Ilhas Geórgias do Sul e Sandwich do Sul',
    value: 'Ilhas Geórgias do Sul e Sandwich do Sul',
  },
  {
    translations: {
      br: 'Coreia do Sul',
      pt: 'Coreia do Sul',
      nl: 'Zuid-Korea',
      hr: 'Južna Koreja',
      fa: 'کره شمالی',
      de: 'Südkorea',
      es: 'Corea del Sur',
      fr: 'Corée du Sud',
      ja: '大韓民国',
      it: 'Corea del Sud',
    },
    name: 'Korea (Republic of)',
    alpha2Code: 'KR',
    callingCodes: [
      '82',
    ],
    label: 'Coreia do Sul',
    value: 'Coreia do Sul',
  },
  {
    translations: {
      br: 'Sudão do Sul',
      pt: 'Sudão do Sul',
      nl: 'Zuid-Soedan',
      hr: 'Južni Sudan',
      fa: 'سودان جنوبی',
      de: 'Südsudan',
      es: 'Sudán del Sur',
      fr: 'Soudan du Sud',
      ja: '南スーダン',
      it: 'Sudan del sud',
    },
    name: 'South Sudan',
    alpha2Code: 'SS',
    callingCodes: [
      '211',
    ],
    label: 'Sudão do Sul',
    value: 'Sudão do Sul',
  },
  {
    translations: {
      br: 'Espanha',
      pt: 'Espanha',
      nl: 'Spanje',
      hr: 'Španjolska',
      fa: 'اسپانیا',
      de: 'Spanien',
      es: 'España',
      fr: 'Espagne',
      ja: 'スペイン',
      it: 'Spagna',
    },
    name: 'Spain',
    alpha2Code: 'ES',
    callingCodes: [
      '34',
    ],
    label: 'Espanha',
    value: 'Espanha',
  },
  {
    translations: {
      br: 'Sri Lanka',
      pt: 'Sri Lanka',
      nl: 'Sri Lanka',
      hr: 'Šri Lanka',
      fa: 'سری‌لانکا',
      de: 'Sri Lanka',
      es: 'Sri Lanka',
      fr: 'Sri Lanka',
      ja: 'スリランカ',
      it: 'Sri Lanka',
    },
    name: 'Sri Lanka',
    alpha2Code: 'LK',
    callingCodes: [
      '94',
    ],
    label: 'Sri Lanka',
    value: 'Sri Lanka',
  },
  {
    translations: {
      br: 'Sudão',
      pt: 'Sudão',
      nl: 'Soedan',
      hr: 'Sudan',
      fa: 'سودان',
      de: 'Sudan',
      es: 'Sudán',
      fr: 'Soudan',
      ja: 'スーダン',
      it: 'Sudan',
    },
    name: 'Sudan',
    alpha2Code: 'SD',
    callingCodes: [
      '249',
    ],
    label: 'Sudão',
    value: 'Sudão',
  },
  {
    translations: {
      br: 'Suriname',
      pt: 'Suriname',
      nl: 'Suriname',
      hr: 'Surinam',
      fa: 'سورینام',
      de: 'Suriname',
      es: 'Surinam',
      fr: 'Surinam',
      ja: 'スリナム',
      it: 'Suriname',
    },
    name: 'Suriname',
    alpha2Code: 'SR',
    callingCodes: [
      '597',
    ],
    label: 'Suriname',
    value: 'Suriname',
  },
  {
    translations: {
      br: 'Svalbard',
      pt: 'Svalbard',
      nl: 'Svalbard en Jan Mayen',
      hr: 'Svalbard i Jan Mayen',
      fa: 'سوالبارد و یان ماین',
      de: 'Svalbard und Jan Mayen',
      es: 'Islas Svalbard y Jan Mayen',
      fr: 'Svalbard et Jan Mayen',
      ja: 'スヴァールバル諸島およびヤンマイエン島',
      it: 'Svalbard e Jan Mayen',
    },
    name: 'Svalbard and Jan Mayen',
    alpha2Code: 'SJ',
    callingCodes: [
      '4779',
    ],
    label: 'Svalbard',
    value: 'Svalbard',
  },
  {
    translations: {
      br: 'Suazilândia',
      pt: 'Suazilândia',
      nl: 'Swaziland',
      hr: 'Svazi',
      fa: 'سوازیلند',
      de: 'Swasiland',
      es: 'Suazilandia',
      fr: 'Swaziland',
      ja: 'スワジランド',
      it: 'Swaziland',
    },
    name: 'Swaziland',
    alpha2Code: 'SZ',
    callingCodes: [
      '268',
    ],
    label: 'Suazilândia',
    value: 'Suazilândia',
  },
  {
    translations: {
      br: 'Suécia',
      pt: 'Suécia',
      nl: 'Zweden',
      hr: 'Švedska',
      fa: 'سوئد',
      de: 'Schweden',
      es: 'Suecia',
      fr: 'Suède',
      ja: 'スウェーデン',
      it: 'Svezia',
    },
    name: 'Sweden',
    alpha2Code: 'SE',
    callingCodes: [
      '46',
    ],
    label: 'Suécia',
    value: 'Suécia',
  },
  {
    translations: {
      br: 'Suíça',
      pt: 'Suíça',
      nl: 'Zwitserland',
      hr: 'Švicarska',
      fa: 'سوئیس',
      de: 'Schweiz',
      es: 'Suiza',
      fr: 'Suisse',
      ja: 'スイス',
      it: 'Svizzera',
    },
    name: 'Switzerland',
    alpha2Code: 'CH',
    callingCodes: [
      '41',
    ],
    label: 'Suíça',
    value: 'Suíça',
  },
  {
    translations: {
      br: 'Síria',
      pt: 'Síria',
      nl: 'Syrië',
      hr: 'Sirija',
      fa: 'سوریه',
      de: 'Syrien',
      es: 'Siria',
      fr: 'Syrie',
      ja: 'シリア・アラブ共和国',
      it: 'Siria',
    },
    name: 'Syrian Arab Republic',
    alpha2Code: 'SY',
    callingCodes: [
      '963',
    ],
    label: 'Síria',
    value: 'Síria',
  },
  {
    translations: {
      br: 'Taiwan',
      pt: 'Taiwan',
      nl: 'Taiwan',
      hr: 'Tajvan',
      fa: 'تایوان',
      de: 'Taiwan',
      es: 'Taiwán',
      fr: 'Taïwan',
      ja: '台湾（中華民国）',
      it: 'Taiwan',
    },
    name: 'Taiwan',
    alpha2Code: 'TW',
    callingCodes: [
      '886',
    ],
    label: 'Taiwan',
    value: 'Taiwan',
  },
  {
    translations: {
      br: 'Tajiquistão',
      pt: 'Tajiquistão',
      nl: 'Tadzjikistan',
      hr: 'Tađikistan',
      fa: 'تاجیکستان',
      de: 'Tadschikistan',
      es: 'Tayikistán',
      fr: 'Tadjikistan',
      ja: 'タジキスタン',
      it: 'Tagikistan',
    },
    name: 'Tajikistan',
    alpha2Code: 'TJ',
    callingCodes: [
      '992',
    ],
    label: 'Tajiquistão',
    value: 'Tajiquistão',
  },
  {
    translations: {
      br: 'Tanzânia',
      pt: 'Tanzânia',
      nl: 'Tanzania',
      hr: 'Tanzanija',
      fa: 'تانزانیا',
      de: 'Tansania',
      es: 'Tanzania',
      fr: 'Tanzanie',
      ja: 'タンザニア',
      it: 'Tanzania',
    },
    name: 'Tanzania, United Republic of',
    alpha2Code: 'TZ',
    callingCodes: [
      '255',
    ],
    label: 'Tanzânia',
    value: 'Tanzânia',
  },
  {
    translations: {
      br: 'Tailândia',
      pt: 'Tailândia',
      nl: 'Thailand',
      hr: 'Tajland',
      fa: 'تایلند',
      de: 'Thailand',
      es: 'Tailandia',
      fr: 'Thaïlande',
      ja: 'タイ',
      it: 'Tailandia',
    },
    name: 'Thailand',
    alpha2Code: 'TH',
    callingCodes: [
      '66',
    ],
    label: 'Tailândia',
    value: 'Tailândia',
  },
  {
    translations: {
      br: 'Timor Leste',
      pt: 'Timor Leste',
      nl: 'Oost-Timor',
      hr: 'Istočni Timor',
      fa: 'تیمور شرقی',
      de: 'Timor-Leste',
      es: 'Timor Oriental',
      fr: 'Timor oriental',
      ja: '東ティモール',
      it: 'Timor Est',
    },
    name: 'Timor-Leste',
    alpha2Code: 'TL',
    callingCodes: [
      '670',
    ],
    label: 'Timor Leste',
    value: 'Timor Leste',
  },
  {
    translations: {
      br: 'Togo',
      pt: 'Togo',
      nl: 'Togo',
      hr: 'Togo',
      fa: 'توگو',
      de: 'Togo',
      es: 'Togo',
      fr: 'Togo',
      ja: 'トーゴ',
      it: 'Togo',
    },
    name: 'Togo',
    alpha2Code: 'TG',
    callingCodes: [
      '228',
    ],
    label: 'Togo',
    value: 'Togo',
  },
  {
    translations: {
      br: 'Tokelau',
      pt: 'Toquelau',
      nl: 'Tokelau',
      hr: 'Tokelau',
      fa: 'توکلائو',
      de: 'Tokelau',
      es: 'Islas Tokelau',
      fr: 'Tokelau',
      ja: 'トケラウ',
      it: 'Isole Tokelau',
    },
    name: 'Tokelau',
    alpha2Code: 'TK',
    callingCodes: [
      '690',
    ],
    label: 'Tokelau',
    value: 'Tokelau',
  },
  {
    translations: {
      br: 'Tonga',
      pt: 'Tonga',
      nl: 'Tonga',
      hr: 'Tonga',
      fa: 'تونگا',
      de: 'Tonga',
      es: 'Tonga',
      fr: 'Tonga',
      ja: 'トンガ',
      it: 'Tonga',
    },
    name: 'Tonga',
    alpha2Code: 'TO',
    callingCodes: [
      '676',
    ],
    label: 'Tonga',
    value: 'Tonga',
  },
  {
    translations: {
      br: 'Trinidad e Tobago',
      pt: 'Trindade e Tobago',
      nl: 'Trinidad en Tobago',
      hr: 'Trinidad i Tobago',
      fa: 'ترینیداد و توباگو',
      de: 'Trinidad und Tobago',
      es: 'Trinidad y Tobago',
      fr: 'Trinité et Tobago',
      ja: 'トリニダード・トバゴ',
      it: 'Trinidad e Tobago',
    },
    name: 'Trinidad and Tobago',
    alpha2Code: 'TT',
    callingCodes: [
      '1868',
    ],
    label: 'Trinidad e Tobago',
    value: 'Trinidad e Tobago',
  },
  {
    translations: {
      br: 'Tunísia',
      pt: 'Tunísia',
      nl: 'Tunesië',
      hr: 'Tunis',
      fa: 'تونس',
      de: 'Tunesien',
      es: 'Túnez',
      fr: 'Tunisie',
      ja: 'チュニジア',
      it: 'Tunisia',
    },
    name: 'Tunisia',
    alpha2Code: 'TN',
    callingCodes: [
      '216',
    ],
    label: 'Tunísia',
    value: 'Tunísia',
  },
  {
    translations: {
      br: 'Turquia',
      pt: 'Turquia',
      nl: 'Turkije',
      hr: 'Turska',
      fa: 'ترکیه',
      de: 'Türkei',
      es: 'Turquía',
      fr: 'Turquie',
      ja: 'トルコ',
      it: 'Turchia',
    },
    name: 'Turkey',
    alpha2Code: 'TR',
    callingCodes: [
      '90',
    ],
    label: 'Turquia',
    value: 'Turquia',
  },
  {
    translations: {
      br: 'Turcomenistão',
      pt: 'Turquemenistão',
      nl: 'Turkmenistan',
      hr: 'Turkmenistan',
      fa: 'ترکمنستان',
      de: 'Turkmenistan',
      es: 'Turkmenistán',
      fr: 'Turkménistan',
      ja: 'トルクメニスタン',
      it: 'Turkmenistan',
    },
    name: 'Turkmenistan',
    alpha2Code: 'TM',
    callingCodes: [
      '993',
    ],
    label: 'Turcomenistão',
    value: 'Turcomenistão',
  },
  {
    translations: {
      br: 'Ilhas Turcas e Caicos',
      pt: 'Ilhas Turcas e Caicos',
      nl: 'Turks- en Caicoseilanden',
      hr: 'Otoci Turks i Caicos',
      fa: 'جزایر تورکس و کایکوس',
      de: 'Turks- und Caicosinseln',
      es: 'Islas Turks y Caicos',
      fr: 'Îles Turques-et-Caïques',
      ja: 'タークス・カイコス諸島',
      it: 'Isole Turks e Caicos',
    },
    name: 'Turks and Caicos Islands',
    alpha2Code: 'TC',
    callingCodes: [
      '1649',
    ],
    label: 'Ilhas Turcas e Caicos',
    value: 'Ilhas Turcas e Caicos',
  },
  {
    translations: {
      br: 'Tuvalu',
      pt: 'Tuvalu',
      nl: 'Tuvalu',
      hr: 'Tuvalu',
      fa: 'تووالو',
      de: 'Tuvalu',
      es: 'Tuvalu',
      fr: 'Tuvalu',
      ja: 'ツバル',
      it: 'Tuvalu',
    },
    name: 'Tuvalu',
    alpha2Code: 'TV',
    callingCodes: [
      '688',
    ],
    label: 'Tuvalu',
    value: 'Tuvalu',
  },
  {
    translations: {
      br: 'Uganda',
      pt: 'Uganda',
      nl: 'Oeganda',
      hr: 'Uganda',
      fa: 'اوگاندا',
      de: 'Uganda',
      es: 'Uganda',
      fr: 'Uganda',
      ja: 'ウガンダ',
      it: 'Uganda',
    },
    name: 'Uganda',
    alpha2Code: 'UG',
    callingCodes: [
      '256',
    ],
    label: 'Uganda',
    value: 'Uganda',
  },
  {
    translations: {
      br: 'Ucrânia',
      pt: 'Ucrânia',
      nl: 'Oekraïne',
      hr: 'Ukrajina',
      fa: 'وکراین',
      de: 'Ukraine',
      es: 'Ucrania',
      fr: 'Ukraine',
      ja: 'ウクライナ',
      it: 'Ucraina',
    },
    name: 'Ukraine',
    alpha2Code: 'UA',
    callingCodes: [
      '380',
    ],
    label: 'Ucrânia',
    value: 'Ucrânia',
  },
  {
    translations: {
      br: 'Emirados árabes Unidos',
      pt: 'Emirados árabes Unidos',
      nl: 'Verenigde Arabische Emiraten',
      hr: 'Ujedinjeni Arapski Emirati',
      fa: 'امارات متحده عربی',
      de: 'Vereinigte Arabische Emirate',
      es: 'Emiratos Árabes Unidos',
      fr: 'Émirats arabes unis',
      ja: 'アラブ首長国連邦',
      it: 'Emirati Arabi Uniti',
    },
    name: 'United Arab Emirates',
    alpha2Code: 'AE',
    callingCodes: [
      '971',
    ],
    label: 'Emirados árabes Unidos',
    value: 'Emirados árabes Unidos',
  },
  {
    translations: {
      br: 'Reino Unido',
      pt: 'Reino Unido',
      nl: 'Verenigd Koninkrijk',
      hr: 'Ujedinjeno Kraljevstvo',
      fa: 'بریتانیای کبیر و ایرلند شمالی',
      de: 'Vereinigtes Königreich',
      es: 'Reino Unido',
      fr: 'Royaume-Uni',
      ja: 'イギリス',
      it: 'Regno Unito',
    },
    name: 'United Kingdom of Great Britain and Northern Ireland',
    alpha2Code: 'GB',
    callingCodes: [
      '44',
    ],
    label: 'Reino Unido',
    value: 'Reino Unido',
  },
  {
    translations: {
      br: 'Estados Unidos',
      pt: 'Estados Unidos',
      nl: 'Verenigde Staten',
      hr: 'Sjedinjene Američke Države',
      fa: 'ایالات متحده آمریکا',
      de: 'Vereinigte Staaten von Amerika',
      es: 'Estados Unidos',
      fr: 'États-Unis',
      ja: 'アメリカ合衆国',
      it: 'Stati Uniti D\'America',
    },
    name: 'United States of America',
    alpha2Code: 'US',
    callingCodes: [
      '1',
    ],
    label: 'Estados Unidos',
    value: 'Estados Unidos',
  },
  {
    translations: {
      br: 'Uruguai',
      pt: 'Uruguai',
      nl: 'Uruguay',
      hr: 'Urugvaj',
      fa: 'اروگوئه',
      de: 'Uruguay',
      es: 'Uruguay',
      fr: 'Uruguay',
      ja: 'ウルグアイ',
      it: 'Uruguay',
    },
    name: 'Uruguay',
    alpha2Code: 'UY',
    callingCodes: [
      '598',
    ],
    label: 'Uruguai',
    value: 'Uruguai',
  },
  {
    translations: {
      br: 'Uzbequistão',
      pt: 'Usbequistão',
      nl: 'Oezbekistan',
      hr: 'Uzbekistan',
      fa: 'ازبکستان',
      de: 'Usbekistan',
      es: 'Uzbekistán',
      fr: 'Ouzbékistan',
      ja: 'ウズベキスタン',
      it: 'Uzbekistan',
    },
    name: 'Uzbekistan',
    alpha2Code: 'UZ',
    callingCodes: [
      '998',
    ],
    label: 'Uzbequistão',
    value: 'Uzbequistão',
  },
  {
    translations: {
      br: 'Vanuatu',
      pt: 'Vanuatu',
      nl: 'Vanuatu',
      hr: 'Vanuatu',
      fa: 'وانواتو',
      de: 'Vanuatu',
      es: 'Vanuatu',
      fr: 'Vanuatu',
      ja: 'バヌアツ',
      it: 'Vanuatu',
    },
    name: 'Vanuatu',
    alpha2Code: 'VU',
    callingCodes: [
      '678',
    ],
    label: 'Vanuatu',
    value: 'Vanuatu',
  },
  {
    translations: {
      br: 'Venezuela',
      pt: 'Venezuela',
      nl: 'Venezuela',
      hr: 'Venezuela',
      fa: 'ونزوئلا',
      de: 'Venezuela',
      es: 'Venezuela',
      fr: 'Venezuela',
      ja: 'ベネズエラ・ボリバル共和国',
      it: 'Venezuela',
    },
    name: 'Venezuela (Bolivarian Republic of)',
    alpha2Code: 'VE',
    callingCodes: [
      '58',
    ],
    label: 'Venezuela',
    value: 'Venezuela',
  },
  {
    translations: {
      br: 'Vietnã',
      pt: 'Vietname',
      nl: 'Vietnam',
      hr: 'Vijetnam',
      fa: 'ویتنام',
      de: 'Vietnam',
      es: 'Vietnam',
      fr: 'Viêt Nam',
      ja: 'ベトナム',
      it: 'Vietnam',
    },
    name: 'Viet Nam',
    alpha2Code: 'VN',
    callingCodes: [
      '84',
    ],
    label: 'Vietnã',
    value: 'Vietnã',
  },
  {
    translations: {
      br: 'Wallis e Futuna',
      pt: 'Wallis e Futuna',
      nl: 'Wallis en Futuna',
      hr: 'Wallis i Fortuna',
      fa: 'والیس و فوتونا',
      de: 'Wallis und Futuna',
      es: 'Wallis y Futuna',
      fr: 'Wallis-et-Futuna',
      ja: 'ウォリス・フツナ',
      it: 'Wallis e Futuna',
    },
    name: 'Wallis and Futuna',
    alpha2Code: 'WF',
    callingCodes: [
      '681',
    ],
    label: 'Wallis e Futuna',
    value: 'Wallis e Futuna',
  },
  {
    translations: {
      br: 'Saara Ocidental',
      pt: 'Saara Ocidental',
      nl: 'Westelijke Sahara',
      hr: 'Zapadna Sahara',
      fa: 'جمهوری دموکراتیک عربی صحرا',
      de: 'Westsahara',
      es: 'Sahara Occidental',
      fr: 'Sahara Occidental',
      ja: '西サハラ',
      it: 'Sahara Occidentale',
    },
    name: 'Western Sahara',
    alpha2Code: 'EH',
    callingCodes: [
      '212',
    ],
    label: 'Saara Ocidental',
    value: 'Saara Ocidental',
  },
  {
    translations: {
      br: 'Iêmen',
      pt: 'Iémen',
      nl: 'Jemen',
      hr: 'Jemen',
      fa: 'یمن',
      de: 'Jemen',
      es: 'Yemen',
      fr: 'Yémen',
      ja: 'イエメン',
      it: 'Yemen',
    },
    name: 'Yemen',
    alpha2Code: 'YE',
    callingCodes: [
      '967',
    ],
    label: 'Iêmen',
    value: 'Iêmen',
  },
  {
    translations: {
      br: 'Zâmbia',
      pt: 'Zâmbia',
      nl: 'Zambia',
      hr: 'Zambija',
      fa: 'زامبیا',
      de: 'Sambia',
      es: 'Zambia',
      fr: 'Zambie',
      ja: 'ザンビア',
      it: 'Zambia',
    },
    name: 'Zambia',
    alpha2Code: 'ZM',
    callingCodes: [
      '260',
    ],
    label: 'Zâmbia',
    value: 'Zâmbia',
  },
  {
    translations: {
      br: 'Zimbabwe',
      pt: 'Zimbabué',
      nl: 'Zimbabwe',
      hr: 'Zimbabve',
      fa: 'زیمباوه',
      de: 'Simbabwe',
      es: 'Zimbabue',
      fr: 'Zimbabwe',
      ja: 'ジンバブエ',
      it: 'Zimbabwe',
    },
    name: 'Zimbabwe',
    alpha2Code: 'ZW',
    callingCodes: [
      '263',
    ],
    label: 'Zimbabwe',
    value: 'Zimbabwe',
  },
];

export const countryNames = {
  BR: 'Brasil',
  PT: 'Portugal',
  AF: 'Afeganistão',
  AX: 'Ilhas de Aland',
  AL: 'Albânia',
  DZ: 'Argélia',
  AS: 'Samoa Americana',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguila',
  AQ: 'Antártida',
  AG: 'Antígua e Barbuda',
  AR: 'Argentina',
  AM: 'Armênia',
  AW: 'Aruba',
  AU: 'Austrália',
  AT: 'áustria',
  AZ: 'Azerbaijão',
  BS: 'Bahamas',
  BH: 'Bahrein',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Bielorrússia',
  BE: 'Bélgica',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermudas',
  BT: 'Butão',
  BO: 'Bolívia',
  BQ: 'Bonaire',
  BA: 'Bósnia e Herzegovina',
  BW: 'Botsuana',
  BV: 'Ilha Bouvet',
  IO: 'Território Britânico do Oceano íÍdico',
  UM: 'Ilhas Menores Distantes dos Estados Unidos',
  VG: 'Ilhas Virgens Britânicas',
  VI: 'Ilhas Virgens Americanas',
  BN: 'Brunei',
  BG: 'Bulgária',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Camboja',
  CM: 'Camarões',
  CA: 'Canadá',
  CV: 'Cabo Verde',
  KY: 'Ilhas Cayman',
  CF: 'República Centro-Africana',
  TD: 'Chade',
  CL: 'Chile',
  CN: 'China',
  CX: 'Ilha Christmas',
  CC: 'Ilhas Cocos',
  CO: 'Colômbia',
  KM: 'Comores',
  CG: 'Congo',
  CD: 'RD Congo',
  CK: 'Ilhas Cook',
  CR: 'Costa Rica',
  HR: 'Croácia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Chipre',
  CZ: 'República Tcheca',
  DK: 'Dinamarca',
  DJ: 'Djibuti',
  DM: 'Dominica',
  DO: 'República Dominicana',
  EC: 'Equador',
  EG: 'Egito',
  SV: 'El Salvador',
  GQ: 'Guiné Equatorial',
  ER: 'Eritreia',
  EE: 'Estônia',
  ET: 'Etiópia',
  FK: 'Ilhas Malvinas',
  FO: 'Ilhas Faroé',
  FJ: 'Fiji',
  FI: 'Finlândia',
  FR: 'França',
  GF: 'Guiana Francesa',
  PF: 'Polinésia Francesa',
  TF: 'Terras Austrais e Antárticas Francesas',
  GA: 'Gabão',
  GM: 'Gâmbia',
  GE: 'Geórgia',
  DE: 'Alemanha',
  GH: 'Gana',
  GI: 'Gibraltar',
  GR: 'Grécia',
  GL: 'Groelândia',
  GD: 'Granada',
  GP: 'Guadalupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guiné',
  GW: 'Guiné-Bissau',
  GY: 'Guiana',
  HT: 'Haiti',
  HM: 'Ilha Heard e Ilhas McDonald',
  VA: 'Vaticano',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungria',
  IS: 'Islândia',
  IN: 'Índia',
  ID: 'Indonésia',
  CI: 'Costa do Marfim',
  IR: 'Irã',
  IQ: 'Iraque',
  IE: 'Irlanda',
  IM: 'Ilha de Man',
  IL: 'Israel',
  IT: 'Itália',
  JM: 'Jamaica',
  JP: 'Japão',
  JE: 'Jersey',
  JO: 'Jordânia',
  KZ: 'Cazaquistão',
  KE: 'Quênia',
  KI: 'Kiribati',
  KW: 'Kuwait',
  KG: 'Quirguistão',
  LA: 'Laos',
  LV: 'Letônia',
  LB: 'Líbano',
  LS: 'Lesoto',
  LR: 'Libéria',
  LY: 'Líbia',
  LI: 'Liechtenstein',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  MO: 'Macau',
  MK: 'Macedônia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malásia',
  MV: 'Maldivas',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Ilhas Marshall',
  MQ: 'Martinica',
  MR: 'Mauritânia',
  MU: 'Maurício',
  YT: 'Mayotte',
  MX: 'México',
  FM: 'Micronésia',
  MD: 'Moldávia',
  MC: 'Mônaco',
  MN: 'Mongólia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marrocos',
  MZ: 'Moçambique',
  MM: 'Myanmar',
  NA: 'Namíbia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Holanda',
  NC: 'Nova Caledônia',
  NZ: 'Nova Zelândia',
  NI: 'Nicarágua',
  NE: 'Níger',
  NG: 'Nigéria',
  NU: 'Niue',
  NF: 'Ilha Norfolk',
  KP: 'Coreia do Norte',
  MP: 'Ilhas Marianas',
  NO: 'Noruega',
  OM: 'Omã',
  PK: 'Paquistão',
  PW: 'Palau',
  PS: 'Palestina',
  PA: 'Panamá',
  PG: 'Papua Nova Guiné',
  PY: 'Paraguai',
  PE: 'Peru',
  PH: 'Filipinas',
  PN: 'Ilhas Pitcairn',
  PL: 'Polônia',
  PR: 'Porto Rico',
  QA: 'Catar',
  XK: 'Kosovo',
  RE: 'Reunião',
  RO: 'Romênia',
  RU: 'Rússia',
  RW: 'Ruanda',
  BL: 'São Bartolomeu',
  SH: 'Santa Helena',
  KN: 'São Cristóvão e Neves',
  LC: 'Santa Lúcia',
  MF: 'Saint Martin',
  PM: 'Saint-Pierre e Miquelon',
  VC: 'São Vicente e Granadinas',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé e Príncipe',
  SA: 'Arábia Saudita',
  SN: 'Senegal',
  RS: 'Sérvia',
  SC: 'Seicheles',
  SL: 'Serra Leoa',
  SG: 'Singapura',
  SX: 'Sint Maarten',
  SK: 'Eslováquia',
  SI: 'Eslovênia',
  SB: 'Ilhas Salomão',
  SO: 'Somália',
  ZA: 'República Sul-Africana',
  GS: 'Ilhas Geórgias do Sul e Sandwich do Sul',
  KR: 'Coreia do Sul',
  SS: 'Sudão do Sul',
  ES: 'Espanha',
  LK: 'Sri Lanka',
  SD: 'Sudão',
  SR: 'Suriname',
  SJ: 'Svalbard',
  SZ: 'Suazilândia',
  SE: 'Suécia',
  CH: 'Suíça',
  SY: 'Síria',
  TW: 'Taiwan',
  TJ: 'Tajiquistão',
  TZ: 'Tanzânia',
  TH: 'Tailândia',
  TL: 'Timor Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad e Tobago',
  TN: 'Tunísia',
  TR: 'Turquia',
  TM: 'Turcomenistão',
  TC: 'Ilhas Turcas e Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ucrânia',
  AE: 'Emirados árabes Unidos',
  GB: 'Reino Unido',
  US: 'Estados Unidos',
  UY: 'Uruguai',
  UZ: 'Uzbequistão',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnã',
  WF: 'Wallis e Futuna',
  EH: 'Saara Ocidental',
  YE: 'Iêmen',
  ZM: 'Zâmbia',
  ZW: 'Zimbabwe',
};
